export const JQ_RISK_CODE = '0301';
export const SY_RISK_CODE = '0312';
export const XNY_RISK_CODE = '0317';

// 主险和附险的关系_0312
export const CS_FJINS = {
    // 车辆损失险
    '030101': ['030110', '030112', '030124', '030128', '030129', '030134', '030135', '030136', '030137', '030138', '030139', 'rate030101'],
    // 三者责任险
    '030102': ['030120', '030134', '030135', '030136', '030137', '030140', '030144', 'rate030102'],
    // 车上人员(司机)
    '030104': ['030105', '030134', '030135', '030136', '030137', '030141', '030145', 'rate030104'],
    // 车上人员(乘客)
    '030105': ['030142', '030146', 'rate030105']
};

// TODO 主险和附险的关系_XNY
export const CS_FJINS_XNY = {
    // 车辆损失险
    '030101': ['030110', '030112', '030124', '030128', '030129', '030134', '030135', '030136', '030137', '030138', '030139', 'rate030101', '030152', '030153', '030155'],
    // 三者责任险
    '030102': ['030120', '030134', '030135', '030136', '030137', '030140', '030144', 'rate030102', '030154', '030156'],
    // 车上人员(司机)
    '030104': ['030105', '030134', '030135', '030136', '030137', '030141', '030145', 'rate030104'],
    // 车上人员(乘客)
    '030105': ['030142', '030146', 'rate030105']
};

//主险和附加险联动--综改后新险别
export const RISK_LIMITS_LINK = [{
    primary: '030101', //车辆损失险
    secondary: ['030110', '030112', '030134', '030135', '030136', '030137', '030138', '030139', 'rate030101'] //车身划痕损失险, 修理费用补偿险,道路救援险,车辆安全检测险,代为驾驶险,代为送检险,发动机进水损坏除外险,车轮单独损失险,绝对免赔率（车损）
}, {
    primary: '030102', //第三者责任保险
    secondary: ['030120', '030134', '030135', '030136', '030137', '030140', '030144', 'rate030102'] //三者假日翻倍险,道路救援险,车辆安全检测险,代为驾驶险,代为送检险,医保外医疗费用责任险（三者）,精神损害抚慰金险（三者）,绝对免赔率（三者）
}, {
    primary: '030104', //车上人员责任险(司机)
    secondary: ['030134', '030135', '030136', '030137', '030141', '030145', 'rate030104'] //车上人员责任险(乘客),道路救援险,车辆安全检测险,代为驾驶险,代为送检险,医保外医疗费用责任险（司机）,精神损害抚慰金险（司机）,绝对免赔率（司机）
}, {
    primary: '030105', //车上人员责任险(乘客)
    secondary: ['030142', '030146', 'rate030105'] //医保外医疗费用责任险（乘客）,精神损害抚慰金险（乘客）,绝对免赔率（乘客）
}];

// TODO 主险和附加险联动--综改后新险别_XNY
export const RISK_LIMITS_LINK_XNY = [{
    primary: '030101', //车辆损失险
    secondary: ['030110', '030112', '030134', '030135', '030136', '030137', '030138', '030139', 'rate030101', '030152', '030153', '030155'] //车身划痕损失险, 修理费用补偿险,道路救援险,车辆安全检测险,代为驾驶险,代为送检险,发动机进水损坏除外险,车轮单独损失险,绝对免赔率（车损）,附加外部电网故障损失险,附加自用充电桩损失保险,附加自动驾驶软件（OTA）损失补偿险
}, {
    primary: '030102', //第三者责任保险
    secondary: ['030120', '030134', '030135', '030136', '030137', '030140', '030144', 'rate030102', '030154', '030156'] //三者假日翻倍险,道路救援险,车辆安全检测险,代为驾驶险,代为送检险,医保外医疗费用责任险（三者）,精神损害抚慰金险（三者）,绝对免赔率（三者）,附加自用充电桩责任保险,附加火灾事故限额翻倍险
}, {
    primary: '030104', //车上人员责任险(司机)
    secondary: ['030134', '030135', '030136', '030137', '030141', '030145', 'rate030104'] //车上人员责任险(乘客),道路救援险,车辆安全检测险,代为驾驶险,代为送检险,医保外医疗费用责任险（司机）,精神损害抚慰金险（司机）,绝对免赔率（司机）
}, {
    primary: '030105', //车上人员责任险(乘客)
    secondary: ['030142', '030146', 'rate030105'] //医保外医疗费用责任险（乘客）,精神损害抚慰金险（乘客）,绝对免赔率（乘客）
}];

export const RISK_TIPS = {
    '030101': { 'name': '车辆损失险', 'rely': [], 'tips': '保险期间内，被保险人或被保险机动车驾驶人在使用被保险机动车过程中，因自然灾害、意外事故造成被保险机动车直接损失，且不属于免除保险人责任的范围，保险人依照保险合同的约定负责赔偿。2020版机动车商业保险，车损险合并了全车盗抢险、自燃损失险、玻璃单独破碎险、发动机涉水损失险、无法找到第三方特约险、指定修理厂险，不计免赔率险等7项险别责任。', },
    '030102': { 'name': '三者责任险', 'rely': [], 'tips': '保险期间内，被保险人或其允许的驾驶人在使用被保险机动车过程中发生意外事故，致使第三者遭受人身伤亡或财产直接损毁，依法应当对第三者承担的损害赔偿责任，且不属于免除保险人责任的范围，保险人依照保险合同的约定，对于超过机动车交通事故责任强制保险各分项赔偿限额的部分负责赔偿。三者险责任限额选项由5万元-500万元调整为10万元-1000万元。', },
    '030104': { 'name': '车上人员（司机）', 'rely': [], 'tips': '保险期间内，被保险人或其允许的驾驶人在使用被保险机动车过程中发生意外事故，致使车上人员遭受人身伤亡，且不属于免除保险人责任的范围，依法应当对车上人员承担的损害赔偿责任，保险人依照本保险合同的约定负责赔偿。', },
    '030105': { 'name': '车上人员（乘客）', 'rely': [], 'tips': '保险期间内，被保险人或其允许的驾驶人在使用被保险机动车过程中发生意外事故，致使车上人员遭受人身伤亡，且不属于免除保险人责任的范围，依法应当对车上人员承担的损害赔偿责任，保险人依照本保险合同的约定负责赔偿。', },
    '030110': { 'name': '车身划痕险', 'rely': ['030104'], 'tips': '保险期间内，被保险机动车在被保险人或被保险机动车驾驶人使用过程中，发生无明显碰撞痕迹的车身划痕损失，保险人按照保险合同约定负责赔偿。', },
    '030112': { 'name': '修理费用补偿险', 'rely': ['030101'], 'tips': '保险期间内，投保了本条款的机动车在使用过程中，发生机动车损失保险责任范围内的事故，造成车身损毁，致使被保险机动车停驶，保险人按保险合同约定，在保险金额内向被保险人补偿修理期间费用，作为代步车费用或弥补停驶损失。', },
    '030120': { 'name': '节假日三者翻倍险', 'rely': ['030102'], 'tips': '保险期间内，被保险人或其允许的驾驶人在法定节假日期间使用被保险机动车发生机动车第三者责任保险范围内的事故，并经公安部门或保险人查勘确认的，被保险机动车第三者责任保险所适用的责任限额在保险单载明的基础上增加一倍。', },
    '030139': { 'name': '车轮单独损失险', 'rely': ['030201', '030101'], 'tips': '保险期间内，被保险人或被保险机动车驾驶人在使用被保险机动车过程中，因自然灾害、意外事故或被盗窃、抢劫、抢夺，导致被保险机动车未发生其他部位的损失、仅有车轮（含轮胎、轮毂、轮毂罩）单独的直接损失，且不属于免除保险人责任的范围，保险人依照本附加险合同的约定负责赔偿。', },
    '030134': { 'name': '道路救援险', 'rely': ['030101', '030102', '030104'], 'tips': '保险期间内，被保险机动车在使用过程中发生故障而丧失行驶能力时，保险人或其受托人根据被保险人请求，向被保险人提供如下道路救援服务。（一）单程50公里以内拖车；（二）送油、送水、送防冻液、搭电；（三）轮胎充气、更换轮胎；（四）车辆脱离困境所需的拖拽、吊车。', },
    '030135': { 'name': '车辆安全检测险', 'rely': ['030101', '030102', '030104'], 'tips': '保险期间内，为保障车辆安全运行，保险人或其受托人根据被保险人请求，为被保险机动车提供车辆安全检测服务，车辆安全检测项目包括：（一）发动机检测（机油、空滤、燃油、冷却等）；（二）变速器检测；（三）转向系统检测（含车轮定位、轮胎动平衡）；（四）底盘检测；（五）轮胎检测；（六）汽车电子系统检测（全车电控系统检测）；（七）车内环境检测；（八）蓄电池检测；（九）车辆综合安全检测。', },
    '030136': { 'name': '代为驾驶险', 'rely': ['030101', '030102', '030104'], 'tips': '保险期间内，保险人或其受托人根据被保险人请求，在被保险人或其允许的驾驶人因饮酒、服用药物等原因无法驾驶或存在重大安全驾驶隐患时提供单程30公里以内的短途代驾服务。', },
    '030137': { 'name': '代为送检险', 'rely': ['030101', '030102', '030104'], 'tips': '保险期间内，按照《中华人民共和国道路交通安全法实施条例》，被保险机动车需由机动车安全技术检验机构实施安全技术检验时，根据被保险人请求，由保险人或其受托人代替车辆所有人进行车辆送检。', },
    '030138': { 'name': '发动机进水损坏除外险', 'rely': ['030101'], 'tips': '险期间内，投保了本附加险的被保险机动车在使用过程中，因发动机进水后导致的发动机的直接损毁，保险人不负责赔偿。', },
    '030140': { 'name': '医保外医疗费用责任险（三者）', 'rely': ['030102'], 'tips': '保险期间内，被保险人或其允许的驾驶人在使用被保险机动车的过程中，发生主险保险事故，对于被保险人依照中华人民共和国法律（不含港澳台地区法律）应对第三者或车上人员承担的医疗费用，保险人对超出《道路交通事故受伤人员临床诊疗指南》和国家基本医疗保险同类医疗费用标准的部分负责赔偿。', },
    '030141': { 'name': '医保外医疗费用责任险（司机）', 'rely': ['030104'], 'tips': '保险期间内，被保险人或其允许的驾驶人在使用被保险机动车的过程中，发生主险保险事故，对于被保险人依照中华人民共和国法律（不含港澳台地区法律）应对第三者或车上人员承担的医疗费用，保险人对超出《道路交通事故受伤人员临床诊疗指南》和国家基本医疗保险同类医疗费用标准的部分负责赔偿。', },
    '030142': { 'name': '医保外医疗费用责任险（乘客）', 'rely': ['030105'], 'tips': '保险期间内，被保险人或其允许的驾驶人在使用被保险机动车的过程中，发生主险保险事故，对于被保险人依照中华人民共和国法律（不含港澳台地区法律）应对第三者或车上人员承担的医疗费用，保险人对超出《道路交通事故受伤人员临床诊疗指南》和国家基本医疗保险同类医疗费用标准的部分负责赔偿。', },
    '030144': { 'name': '精神损害抚慰金险（三者）', 'rely': ['030102'], 'tips': '保险期间内，被保险人或其允许的驾驶人在使用被保险机动车的过程中，发生投保的主险约定的保险责任内的事故，造成第三者或车上人员的人身伤亡，受害人据此提出精神损害赔偿请求，保险人依据法院判决及保险合同约定，对应由被保险人或被保险机动车驾驶人支付的精神损害抚慰金，在扣除机动车交通事故责任强制保险应当支付的赔款后，在本保险赔偿限额内负责赔偿。', },
    '030145': { 'name': '精神损害抚慰金险（司机）', 'rely': ['030104'], 'tips': '保险期间内，被保险人或其允许的驾驶人在使用被保险机动车的过程中，发生投保的主险约定的保险责任内的事故，造成第三者或车上人员的人身伤亡，受害人据此提出精神损害赔偿请求，保险人依据法院判决及保险合同约定，对应由被保险人或被保险机动车驾驶人支付的精神损害抚慰金，在扣除机动车交通事故责任强制保险应当支付的赔款后，在本保险赔偿限额内负责赔偿。', },
    '030146': { 'name': '精神损害抚慰金险（乘客）', 'rely': ['030105'], 'tips': '保险期间内，被保险人或其允许的驾驶人在使用被保险机动车的过程中，发生投保的主险约定的保险责任内的事故，造成第三者或车上人员的人身伤亡，受害人据此提出精神损害赔偿请求，保险人依据法院判决及保险合同约定，对应由被保险人或被保险机动车驾驶人支付的精神损害抚慰金，在扣除机动车交通事故责任强制保险应当支付的赔款后，在本保险赔偿限额内负责赔偿。', },
    'rate030101': { 'name': '绝对免赔率（车损）', 'rely': ['030101'], 'tips': '被保险机动车发生主险约定的保险事故，保险人按照主险的约定计算赔款后，扣减本特约条款约定的免赔。', },
    'rate030102': { 'name': '绝对免赔率（三者）', 'rely': ['030102'], 'tips': '被保险机动车发生主险约定的保险事故，保险人按照主险的约定计算赔款后，扣减本特约条款约定的免赔。', },
    'rate030104': { 'name': '绝对免赔率（司机）', 'rely': ['030104'], 'tips': '被保险机动车发生主险约定的保险事故，保险人按照主险的约定计算赔款后，扣减本特约条款约定的免赔。', },
    'rate030105': { 'name': '绝对免赔率（乘客）', 'rely': ['030105'], 'tips': '被保险机动车发生主险约定的保险事故，保险人按照主险的约定计算赔款后，扣减本特约条款约定的免赔。', },
};

export const RISK_TIPS_XNY = {
    '030101': { 'name': '车辆损失险', 'rely': [], 'tips': '保险期间内，被保险人或被保险机动车驾驶人在使用被保险机动车过程中，因自然灾害、意外事故造成被保险机动车直接损失，且不属于免除保险人责任的范围，保险人依照保险合同的约定负责赔偿。2020版机动车商业保险，车损险合并了全车盗抢险、自燃损失险、玻璃单独破碎险、发动机涉水损失险、无法找到第三方特约险、指定修理厂险，不计免赔率险等7项险别责任。', },
    '030102': { 'name': '三者责任险', 'rely': [], 'tips': '保险期间内，被保险人或其允许的驾驶人在使用被保险机动车过程中发生意外事故，致使第三者遭受人身伤亡或财产直接损毁，依法应当对第三者承担的损害赔偿责任，且不属于免除保险人责任的范围，保险人依照保险合同的约定，对于超过机动车交通事故责任强制保险各分项赔偿限额的部分负责赔偿。三者险责任限额选项由5万元-500万元调整为10万元-1000万元。', },
    '030104': { 'name': '车上人员（司机）', 'rely': [], 'tips': '保险期间内，被保险人或其允许的驾驶人在使用被保险机动车过程中发生意外事故，致使车上人员遭受人身伤亡，且不属于免除保险人责任的范围，依法应当对车上人员承担的损害赔偿责任，保险人依照本保险合同的约定负责赔偿。', },
    '030105': { 'name': '车上人员（乘客）', 'rely': [], 'tips': '保险期间内，被保险人或其允许的驾驶人在使用被保险机动车过程中发生意外事故，致使车上人员遭受人身伤亡，且不属于免除保险人责任的范围，依法应当对车上人员承担的损害赔偿责任，保险人依照本保险合同的约定负责赔偿。', },
    '030110': { 'name': '车身划痕险', 'rely': ['030104'], 'tips': '保险期间内，被保险机动车在被保险人或被保险机动车驾驶人使用过程中，发生无明显碰撞痕迹的车身划痕损失，保险人按照保险合同约定负责赔偿。', },
    '030112': { 'name': '修理费用补偿险', 'rely': ['030101'], 'tips': '保险期间内，投保了本条款的机动车在使用过程中，发生机动车损失保险责任范围内的事故，造成车身损毁，致使被保险机动车停驶，保险人按保险合同约定，在保险金额内向被保险人补偿修理期间费用，作为代步车费用或弥补停驶损失。', },
    '030120': { 'name': '节假日三者翻倍险', 'rely': ['030102'], 'tips': '保险期间内，被保险人或其允许的驾驶人在法定节假日期间使用被保险机动车发生机动车第三者责任保险范围内的事故，并经公安部门或保险人查勘确认的，被保险机动车第三者责任保险所适用的责任限额在保险单载明的基础上增加一倍。', },
    '030139': { 'name': '车轮单独损失险', 'rely': ['030201', '030101'], 'tips': '保险期间内，被保险人或被保险机动车驾驶人在使用被保险机动车过程中，因自然灾害、意外事故或被盗窃、抢劫、抢夺，导致被保险机动车未发生其他部位的损失、仅有车轮（含轮胎、轮毂、轮毂罩）单独的直接损失，且不属于免除保险人责任的范围，保险人依照本附加险合同的约定负责赔偿。', },
    '030134': { 'name': '道路救援险', 'rely': ['030101', '030102', '030104'], 'tips': '保险期间内，被保险机动车在使用过程中发生故障而丧失行驶能力时，保险人或其受托人根据被保险人请求，向被保险人提供如下道路救援服务。（一）单程50公里以内拖车；（二）送油、送水、送防冻液、搭电；（三）轮胎充气、更换轮胎；（四）车辆脱离困境所需的拖拽、吊车。', },
    '030135': { 'name': '车辆安全检测险', 'rely': ['030101', '030102', '030104'], 'tips': '保险期间内，为保障车辆安全运行，保险人或其受托人根据被保险人请求，为被保险机动车提供车辆安全检测服务，车辆安全检测项目包括：（一）发动机检测（机油、空滤、燃油、冷却等）；（二）变速器检测；（三）转向系统检测（含车轮定位、轮胎动平衡）；（四）底盘检测；（五）轮胎检测；（六）汽车电子系统检测（全车电控系统检测）；（七）车内环境检测；（八）蓄电池检测；（九）车辆综合安全检测。', },
    '030136': { 'name': '代为驾驶险', 'rely': ['030101', '030102', '030104'], 'tips': '保险期间内，保险人或其受托人根据被保险人请求，在被保险人或其允许的驾驶人因饮酒、服用药物等原因无法驾驶或存在重大安全驾驶隐患时提供单程30公里以内的短途代驾服务。', },
    '030137': { 'name': '代为送检险', 'rely': ['030101', '030102', '030104'], 'tips': '保险期间内，按照《中华人民共和国道路交通安全法实施条例》，被保险机动车需由机动车安全技术检验机构实施安全技术检验时，根据被保险人请求，由保险人或其受托人代替车辆所有人进行车辆送检。', },
    '030138': { 'name': '发动机进水损坏除外险', 'rely': ['030101'], 'tips': '险期间内，投保了本附加险的被保险机动车在使用过程中，因发动机进水后导致的发动机的直接损毁，保险人不负责赔偿。', },
    '030140': { 'name': '医保外医疗费用责任险（三者）', 'rely': ['030102'], 'tips': '保险期间内，被保险人或其允许的驾驶人在使用被保险机动车的过程中，发生主险保险事故，对于被保险人依照中华人民共和国法律（不含港澳台地区法律）应对第三者或车上人员承担的医疗费用，保险人对超出《道路交通事故受伤人员临床诊疗指南》和国家基本医疗保险同类医疗费用标准的部分负责赔偿。', },
    '030141': { 'name': '医保外医疗费用责任险（司机）', 'rely': ['030104'], 'tips': '保险期间内，被保险人或其允许的驾驶人在使用被保险机动车的过程中，发生主险保险事故，对于被保险人依照中华人民共和国法律（不含港澳台地区法律）应对第三者或车上人员承担的医疗费用，保险人对超出《道路交通事故受伤人员临床诊疗指南》和国家基本医疗保险同类医疗费用标准的部分负责赔偿。', },
    '030142': { 'name': '医保外医疗费用责任险（乘客）', 'rely': ['030105'], 'tips': '保险期间内，被保险人或其允许的驾驶人在使用被保险机动车的过程中，发生主险保险事故，对于被保险人依照中华人民共和国法律（不含港澳台地区法律）应对第三者或车上人员承担的医疗费用，保险人对超出《道路交通事故受伤人员临床诊疗指南》和国家基本医疗保险同类医疗费用标准的部分负责赔偿。', },
    '030144': { 'name': '精神损害抚慰金险（三者）', 'rely': ['030102'], 'tips': '保险期间内，被保险人或其允许的驾驶人在使用被保险机动车的过程中，发生投保的主险约定的保险责任内的事故，造成第三者或车上人员的人身伤亡，受害人据此提出精神损害赔偿请求，保险人依据法院判决及保险合同约定，对应由被保险人或被保险机动车驾驶人支付的精神损害抚慰金，在扣除机动车交通事故责任强制保险应当支付的赔款后，在本保险赔偿限额内负责赔偿。', },
    '030145': { 'name': '精神损害抚慰金险（司机）', 'rely': ['030104'], 'tips': '保险期间内，被保险人或其允许的驾驶人在使用被保险机动车的过程中，发生投保的主险约定的保险责任内的事故，造成第三者或车上人员的人身伤亡，受害人据此提出精神损害赔偿请求，保险人依据法院判决及保险合同约定，对应由被保险人或被保险机动车驾驶人支付的精神损害抚慰金，在扣除机动车交通事故责任强制保险应当支付的赔款后，在本保险赔偿限额内负责赔偿。', },
    '030146': { 'name': '精神损害抚慰金险（乘客）', 'rely': ['030105'], 'tips': '保险期间内，被保险人或其允许的驾驶人在使用被保险机动车的过程中，发生投保的主险约定的保险责任内的事故，造成第三者或车上人员的人身伤亡，受害人据此提出精神损害赔偿请求，保险人依据法院判决及保险合同约定，对应由被保险人或被保险机动车驾驶人支付的精神损害抚慰金，在扣除机动车交通事故责任强制保险应当支付的赔款后，在本保险赔偿限额内负责赔偿。', },
    'rate030101': { 'name': '绝对免赔率（车损）', 'rely': ['030101'], 'tips': '被保险机动车发生主险约定的保险事故，保险人按照主险的约定计算赔款后，扣减本特约条款约定的免赔。', },
    'rate030102': { 'name': '绝对免赔率（三者）', 'rely': ['030102'], 'tips': '被保险机动车发生主险约定的保险事故，保险人按照主险的约定计算赔款后，扣减本特约条款约定的免赔。', },
    'rate030104': { 'name': '绝对免赔率（司机）', 'rely': ['030104'], 'tips': '被保险机动车发生主险约定的保险事故，保险人按照主险的约定计算赔款后，扣减本特约条款约定的免赔。', },
    'rate030105': { 'name': '绝对免赔率（乘客）', 'rely': ['030105'], 'tips': '被保险机动车发生主险约定的保险事故，保险人按照主险的约定计算赔款后，扣减本特约条款约定的免赔。', },
    '030152': { 'name': '外部电网故障险', 'rely': ['030101'], 'tips': '附加外部电网故障损失。', }, // TODO 新能源
    '030153': { 'name': '充电桩损失险', 'rely': ['030101'], 'tips': '附加自用充电桩损失保险', }, // TODO 新能源
    '030154': { 'name': '充电桩责任险', 'rely': ['030102'], 'tips': '附加自用充电桩责任保险', }, // TODO 新能源
    '030155': { 'name': 'OTA损失补偿险', 'rely': ['030101'], 'tips': '附加自动驾驶软件（OTA）损失补偿险。', }, // TODO 新能源
    '030156': { 'name': '火灾事故翻倍险', 'rely': ['030102'], 'tips': '附加火灾事故限额翻倍险。', }, // TODO 新能源
};

// 影响上传提示信息
export const IMG_TIPS = [
    '若您的车是过户车或新车尚未上牌，请提供身份证正反面影像哦，拍摄时请注意照片清晰、无反光、四角完整。若不确定是否需要上传身份证影像，可向您的业务员咨询。',
    '若您的车是过户车或新车尚未上牌，请提供驾驶证正副页影像哦，拍摄时请注意照片清晰、无反光、四角完整。若不确定是否需要上传驾驶证正副页影像，可向您的业务员咨询',
    '若您之前购买的商业险已脱保或者是新车投保，亦或者本次有新增购买车损类险别，需提供车的右前、右后、左前、左后四个对角，仪表盘以及车架号的照片哦。留意验车拍摄时需购买当地当日的报纸与车辆进行合照，或用一张纸写上清晰可见的验车码与车辆进行合照也可以当成验车照片哦！若不确定是否需要上传验车照片，可向您的业务员咨询。',
    '若您是新车投保或者异地车投保，则需要提供车辆与当地景点的合照哦，景点可以是当地酒店、公交站、饭馆或知名地标。注意拍摄时需购买当地当日的报纸与车辆进行合照，或用一张纸写上清晰可见的验车码与车辆进行合照也可以作为车辆与地标合照哦！若不确定是否需要上传车辆与地标合照，可向您的业务员咨询。',
    '若您的车是新车尚未上牌，请提供合格证和购车发票哦，拍摄时请注意照片清晰、无反光、四角完整。若不确定是否需要上传合格证和购车发票影像，可向您的业务员咨询',
];

// 险别关系  综合示范型条款(0312)
export const RISK_RELATION = {
    // 主险 原基本型
    '030101': {
        name: '车辆损失险',
        unit: '元',
        rely: [],
        decide: [
            '030110', //车身划痕损失险
            '030112', //修理期间费用补偿险
            '030139', //车轮单独损坏除外特约
            '021', //绝对免赔率特约险
            '030134', //道路救援服务特约
            '030135', //车辆安全检测特约
            '030136', //代为驾驶服务特约
            '030137', //代为送检服务特约
            'rate030101', //绝对免赔率特约险(车损)
        ],
    },
    '030102': {
        name: '三者责任险',
        unit: '元',
        rely: [],
        decide: [
            '030113', //车上货物责任险
            '030120', //法定节假日限额翻倍险
            '021', //绝对免赔率特约险
            '030134', //道路救援服务特约
            '030135', //车辆安全检测特约
            '030136', //代为驾驶服务特约
            '030137', //代为送检服务特约
            '030140', //附加医保外医疗费用责任险(三者)
            '030144', //精神损害抚慰金责任险(三者)
            'rate030102', //绝对免赔率特约险(三者)
        ],
    },
    '030104': {
        name: '车上人员(司机)',
        unit: '元',
        quantityUnit: '座',
        rely: [],
        decide: [
            '030113', //车上货物责任险
            '030105', //车上人员责任保险（乘客）
            '021', //绝对免赔率特约险
            '030134', //道路救援服务特约
            '030135', //车辆安全检测特约
            '030136', //代为驾驶服务特约
            '030137', //代为送检服务特约
            '030141', //附加医保外医疗费用责任险(司机)
            '030145', //精神损害抚慰金责任险(司机)
            '030142', //附加医保外医疗费用责任险(乘客)
            '030146', //精神损害抚慰金责任险(乘客)
            'rate030104', //绝对免赔率特约险(司机)
        ],
    },
    '030105': {
        name: '车上人员(乘客)',
        unit: '元',
        quantityUnit: '座',
        rely: ['030104'], //主险
        decide: [
            '030142', //附加医保外医疗费用责任险(乘客)
            '030146', //精神损害抚慰金责任险(乘客)
            'rate030105', //绝对免赔率特约险(乘客)
        ], //副险
    },
    // 附加险
    '030110': { name: '车身划痕险', unit: '元', rely: ['030101'], decide: [] },
    '030138': { name: '发动机进水损坏除外险', unit: '元', rely: ['030101'], decide: [] },
    '030112': { name: '修理费用补偿险', unit: '元', quantityUnit: '天', rely: ['030101'], decide: [] },
    '030113': { name: '车上货物责任险', unit: '元', rely: ['030102', '030104', '030105'], decide: [] },
    '030114': { name: '精神损害抚慰金责任险', unit: '元', rely: [], decide: [] },
    '030120': { name: '三者假日翻倍险', unit: '元', rely: ['030102'], decide: [] },
    '030139': { name: '车轮单独损失险', rely: ['030201', '030101'], decide: [] },
    '021': { name: '免赔额', rely: ['030101', '030102', '030104'], decide: [] },
    '030124': { name: '保险人指定修理厂特约险', rely: [], decide: [] },
    '030140': { name: '医保外医疗费用责任险（三者）', rely: ['030102'], decide: [] },
    '030141': { name: '医保外医疗费用责任险（司机）', quantityUnit: '座', rely: ['030104'], decide: [] },
    '030142': { name: '医保外医疗费用责任险（乘客）', quantityUnit: '座', rely: ['030105'], decide: [] },
    '030144': { name: '精神损害抚慰金险（三者）', rely: ['030102'], decide: [] },
    '030145': { name: '精神损害抚慰金险（司机）', quantityUnit: '座', rely: ['030104'], decide: [] },
    '030146': { name: '精神损害抚慰金险（乘客）', quantityUnit: '座', rely: ['030105'], decide: [] },
    '030134': { name: '道路救援险', rely: ['030101', '030102', '030104'], decide: [] },
    '030135': { name: '车辆安全检测险', rely: ['030101', '030102', '030104'], decide: [] },
    '030136': { name: '代为驾驶服务', rely: ['030101', '030102', '030104'], decide: [] },
    '030137': { name: '代为送检险', rely: ['030101', '030102', '030104'], decide: [] },
    'rate030101': { name: '绝对免赔率(车损)', rely: ['030101'], decide: [] },
    'rate030102': { name: '绝对免赔率(三者)', rely: ['030102'], decide: [] },
    'rate030104': { name: '绝对免赔率(司机)', rely: ['030104'], decide: [] },
    'rate030105': { name: '绝对免赔率(乘客)', rely: ['030105'], decide: [] },
};

// 展示暂存单里的险别
export const LATELY_VERSION_LIST = [
    '030101',
    '030102',
    '030104',
    '030105',
    '030110',
    '030112',
    '030120',
    '030134',
    '030135',
    '030136',
    '030137',
    '030138',
    '030139',
    '030140',
    '030141',
    '030142',
    '030144',
    '030145',
    '030146'
];
// 展示暂存单里的险别(新能源)
export const LATELY_VERSION_LIST_XNY = [
    '030101',
    '030102',
    '030104',
    '030105',
    '030110',
    '030112',
    '030120',
    '030134',
    '030135',
    '030136',
    '030137',
    '030138',
    '030139',
    '030140',
    '030141',
    '030142',
    '030144',
    '030145',
    '030146',
    // 'rate030101',
    // 'rate030102',
    // 'rate030103',
    // 'rate030104',
    // 'rate030105',
    // '021',
    // '030152',
    // '030153',
    // '030154',
    // '030155',
    // '030156',
];

//TODO 显示‘新’标志
export const COVERAGE_NEW = ["030152", "030153", "030154", "030155", "030156"];

// 综合示范型条款(0312)
export const COVERAGE_List = [{
        /* 车辆损失保险 */
        name: '车辆损失险', // 险种名称
        deductible: '0', // 免赔额
        deductibleRate: '0', // 绝对免赔率
        nonDeductiblePremium: '', // 免赔率保费
        kindCode: '030101', // 险种代码
        kindInd: '1', // 主险标志
        relatedInd: '0', // 不计免赔
        sumInsured: '', // 险种保额
        renewal: '', // 带出上年险种标识
        checked: false, // 是否选中
        relatedIndChecked: false,
        clauseTypes: '0',
        disabled: false,
    },
    {
        /* 商业第三者责任保险 */
        name: '三者责任险',
        deductibleRate: '0',
        nonDeductiblePremium: '',
        kindCode: '030102',
        kindInd: '1',
        relatedInd: '0',
        sumInsured: '500000',
        checked: false,
        relatedIndChecked: false,
        clauseTypes: '0',
        disabled: false,
    },
    {
        /* 车上人员责任保险（司机）  */
        name: '车上人员（司机）',
        deductibleRate: '0',
        nonDeductiblePremium: '',
        kindCode: '030104',
        kindInd: '1',
        relatedInd: '0',
        sumInsured: '',
        unitInsured: '10000',
        checked: false,
        relatedIndChecked: false,
        clauseTypes: '0',
        disabled: false,
    },
    {
        /* 车上人员责任保险（乘客） */
        name: '车上人员（乘客）',
        deductibleRate: '0',
        nonDeductiblePremium: '',
        kindCode: '030105',
        quantity: '',
        relatedInd: '0',
        sumInsured: '',
        unitInsured: '10000',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    {
        /* 车身划痕损失险 */
        name: '车身划痕险',
        kindCode: '030110',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '2000',
        unitInsured: '',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    {
        /* 修理期间费用补偿险  */
        name: '修理费用补偿险',
        kindCode: '030112',
        quantity: 20,
        relatedInd: '0',
        sumInsured: '',
        unitInsured: '20',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    {
        /* 三者假日翻倍险  */
        name: '三者假日翻倍险',
        kindCode: '030120',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '500000',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    {
        /* 道路救援服务特约 */
        name: '道路救援险',
        kindCode: '030134',
        kindInd: '2',
        relatedInd: '0',
        quantity: '2', //次数
        sumInsured: '0',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    {
        /* 车辆安全检测特约 */
        name: '车辆安全检测险',
        kindCode: '030135',
        kindInd: '2',
        relatedInd: '0',
        quantity: 1, //次数
        sumInsured: '0',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    {
        /* 代为驾驶服务特约 */
        name: '代为驾驶服务',
        kindCode: '030136',
        kindInd: '2',
        relatedInd: '0',
        quantity: 1, //次数
        sumInsured: '0',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    {
        /* 代为送检服务特约 */
        name: '代为送检险',
        kindCode: '030137',
        kindInd: '2',
        relatedInd: '0',
        quantity: 1,
        sumInsured: '0',
        checked: false,
        disabled: false,
        clauseTypes: '0',
        valueType: '', // 默认空， 0：免过线 1：需过线
    },
    {
        /* 附加发动机进水损坏除外特约  */
        name: '发动机进水损坏除外险',
        kindCode: '030138',
        relatedInd: '0',
        sumInsured: '0',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    {
        /* 车轮单独损坏除外特约 */
        name: '车轮单独损失险',
        kindCode: '030139',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '1000',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    {
        /* 附加医保外医疗费用责任险（三者） */
        name: '医保外医疗费用责任险（三者）',
        kindCode: '030140',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '',
        checked: false,
        disabled: false,
        clauseTypes: '0',
    },
    {
        /* 附加医保外医疗费用责任险（司机） */
        name: '医保外医疗费用责任险（司机）',
        kindCode: '030141',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '',
        quantity: '1',
        unitInsured: '',
        checked: false,
        disabled: false,
        clauseTypes: '0',
    },
    {
        /* 附加医保外医疗费用责任险（乘客） */
        name: '医保外医疗费用责任险（乘客）',
        kindCode: '030142',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '',
        unitInsured: '',
        quantity: '',
        checked: false,
        disabled: false,
        clauseTypes: '0',
    },
    {
        /* 精神损害抚慰金责任险（三者） */
        name: '精神损害抚慰金险（三者）',
        kindCode: '030144',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '',
        checked: false,
        disabled: false,
        clauseTypes: '0',
    },
    {
        /* 精神损害抚慰金责任险（司机） */
        name: '精神损害抚慰金险（司机）',
        kindCode: '030145',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '',
        unitInsured: '',
        quantity: '1',
        checked: false,
        disabled: false,
        clauseTypes: '0',
    },
    {
        /* 精神损害抚慰金责任险（乘客） */
        name: '精神损害抚慰金险（乘客）',
        kindCode: '030146',
        kindInd: '2',
        relatedInd: '0',
        unitInsured: '',
        sumInsured: '',
        quantity: '',
        checked: false,
        disabled: false,
        clauseTypes: '0',
    },
    {
        /* 绝对免赔率特约险（车损） */
        name: '绝对免赔率(车损)',
        kindCode: 'rate030101',
        relatedInd: '0',
        checked: false,
        disabled: false,
        clauseTypes: '0',
        isNoQuote: true,
        rate: '5'
    },
    {
        /* 绝对免赔率特约险（三者） */
        name: '绝对免赔率(三者)',
        kindCode: 'rate030102',
        relatedInd: '0',
        checked: false,
        disabled: false,
        clauseTypes: '0',
        isNoQuote: true,
        rate: '5'
    },
    {
        /* 绝对免赔率特约险（司机） */
        name: '绝对免赔率(司机)',
        kindCode: 'rate030104',
        relatedInd: '0',
        checked: false,
        disabled: false,
        clauseTypes: '0',
        isNoQuote: true,
        rate: '5'
    },
    {
        /* 绝对免赔率特约险（乘客） */
        name: '绝对免赔率(乘客)',
        kindCode: 'rate030105',
        relatedInd: '0',
        checked: false,
        disabled: false,
        clauseTypes: '0',
        isNoQuote: true,
        rate: '5'
    },
    {
        /* 绝对免赔率特约险*/
        name: '绝对免赔率特约险',
        deductible: '',
        kindCode: '021',
        kindInd: '2',
        quantity: '',
        relatedInd: '0',
        nonDeductiblePremium: '',
        sumInsured: '',
        unitInsured: '',
        rate: '0',
        valueType: '',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '',
    },
];

// 山东运营车展示险别
export const COVERAGE_List_Sd = [{
        /* 车辆损失保险 */
        name: '车辆损失险', // 险种名称
        deductible: '0', // 免赔额
        deductibleRate: '0', // 绝对免赔率
        nonDeductiblePremium: '', // 免赔率保费
        kindCode: '030101', // 险种代码
        kindInd: '1', // 主险标志
        relatedInd: '0', // 不计免赔
        sumInsured: '', // 险种保额
        renewal: '', // 带出上年险种标识
        checked: false, // 是否选中
        relatedIndChecked: false,
        clauseTypes: '0',
        disabled: false,
    },
    {
        /* 商业第三者责任保险 */
        name: '三者责任险',
        deductibleRate: '0',
        nonDeductiblePremium: '',
        kindCode: '030102',
        kindInd: '1',
        relatedInd: '0',
        sumInsured: '500000',
        checked: false,
        relatedIndChecked: false,
        clauseTypes: '0',
        disabled: false,
    },
    {
        /* 车上人员责任保险（司机）  */
        name: '车上人员（司机）',
        deductibleRate: '0',
        nonDeductiblePremium: '',
        kindCode: '030104',
        kindInd: '1',
        relatedInd: '0',
        sumInsured: '',
        unitInsured: '10000',
        checked: false,
        relatedIndChecked: false,
        clauseTypes: '0',
        disabled: false,
    },
    {
        /* 车上人员责任保险（乘客） */
        name: '车上人员（乘客）',
        deductibleRate: '0',
        nonDeductiblePremium: '',
        kindCode: '030105',
        quantity: '',
        relatedInd: '0',
        sumInsured: '',
        unitInsured: '10000',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    {
        /* 附加医保外医疗费用责任险（三者） */
        name: '医保外医疗费用责任险（三者）',
        kindCode: '030140',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '',
        checked: false,
        disabled: false,
        clauseTypes: '0',
    },
    {
        /* 精神损害抚慰金责任险（三者） */
        name: '精神损害抚慰金险（三者）',
        kindCode: '030144',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '',
        checked: false,
        disabled: false,
        clauseTypes: '0',
    },
    {
        /* 绝对免赔率特约险（车损） */
        name: '绝对免赔率(车损)',
        kindCode: 'rate030101',
        relatedInd: '0',
        checked: false,
        disabled: false,
        clauseTypes: '0',
        isNoQuote: true,
        rate: '5'
    },
    {
        /* 绝对免赔率特约险（三者） */
        name: '绝对免赔率(三者)',
        kindCode: 'rate030102',
        relatedInd: '0',
        checked: false,
        disabled: false,
        clauseTypes: '0',
        isNoQuote: true,
        rate: '5'
    },
    {
        /* 绝对免赔率特约险（司机） */
        name: '绝对免赔率(司机)',
        kindCode: 'rate030104',
        relatedInd: '0',
        checked: false,
        disabled: false,
        clauseTypes: '0',
        isNoQuote: true,
        rate: '5'
    },
    {
        /* 绝对免赔率特约险（乘客） */
        name: '绝对免赔率(乘客)',
        kindCode: 'rate030105',
        relatedInd: '0',
        checked: false,
        disabled: false,
        clauseTypes: '0',
        isNoQuote: true,
        rate: '5'
    },
    {
        /* 绝对免赔率特约险*/
        name: '绝对免赔率特约险',
        deductible: '',
        kindCode: '021',
        kindInd: '2',
        quantity: '',
        relatedInd: '0',
        nonDeductiblePremium: '',
        sumInsured: '',
        unitInsured: '',
        rate: '0',
        valueType: '',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '',
    },
    {
        /* 车辆安全检测特约 */
        name: '车辆安全检测险',
        kindCode: '030135',
        kindInd: '2',
        relatedInd: '0',
        quantity: 1, //次数
        sumInsured: '0',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    {
        /* 代为驾驶服务特约 */
        name: '代为驾驶服务',
        kindCode: '030136',
        kindInd: '2',
        relatedInd: '0',
        quantity: 1, //次数
        sumInsured: '0',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    {
        /* 代为送检服务特约 */
        name: '代为送检险',
        kindCode: '030137',
        kindInd: '2',
        relatedInd: '0',
        quantity: 1,
        sumInsured: '0',
        checked: false,
        disabled: false,
        clauseTypes: '0',
        valueType: '1', // 默认需过线， 0：免过线 1：需过线
    },
];

// 新能源示范型条款(0317)，险种数据
export const COVERAGE_List_XNY = [{
        /* 车辆损失保险 */
        name: '车辆损失险', // 险种名称
        deductible: '0', // 免赔额
        deductibleRate: '0', // 绝对免赔率
        nonDeductiblePremium: '', // 免赔率保费
        kindCode: '030101', // 险种代码
        kindInd: '1', // 主险标志
        relatedInd: '0', // 不计免赔
        sumInsured: '', // 险种保额
        renewal: '', // 带出上年险种标识
        checked: false, // 是否选中
        relatedIndChecked: false,
        clauseTypes: '0',
        disabled: false,
    },
    {
        /* 商业第三者责任保险 */
        name: '三者责任险',
        deductibleRate: '0',
        nonDeductiblePremium: '',
        kindCode: '030102',
        kindInd: '1',
        relatedInd: '0',
        sumInsured: '500000',
        checked: false,
        relatedIndChecked: false,
        clauseTypes: '0',
        disabled: false,
    },
    {
        /* 车上人员责任保险（司机）  */
        name: '车上人员（司机）',
        deductibleRate: '0',
        nonDeductiblePremium: '',
        kindCode: '030104',
        kindInd: '1',
        relatedInd: '0',
        sumInsured: '',
        unitInsured: '10000',
        checked: false,
        relatedIndChecked: false,
        clauseTypes: '0',
        disabled: false,
    },
    {
        /* 车上人员责任保险（乘客） */
        name: '车上人员（乘客）',
        deductibleRate: '0',
        nonDeductiblePremium: '',
        kindCode: '030105',
        quantity: '',
        relatedInd: '0',
        sumInsured: '',
        unitInsured: '10000',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    {
        /* 车身划痕损失险 */
        name: '车身划痕险',
        kindCode: '030110',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '2000',
        unitInsured: '',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    {
        /* 修理期间费用补偿险  */
        name: '修理费用补偿险',
        kindCode: '030112',
        quantity: 20,
        relatedInd: '0',
        sumInsured: '',
        unitInsured: '20',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    {
        /* 三者假日翻倍险  */
        name: '三者假日翻倍险',
        kindCode: '030120',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '500000',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    {
        /* 道路救援服务特约 */
        name: '道路救援险',
        kindCode: '030134',
        kindInd: '2',
        relatedInd: '0',
        quantity: '2', //次数
        sumInsured: '0',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    {
        /* 车辆安全检测特约 */
        name: '车辆安全检测险',
        kindCode: '030135',
        kindInd: '2',
        relatedInd: '0',
        quantity: 1, //次数
        sumInsured: '0',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    {
        /* 代为驾驶服务特约 */
        name: '代为驾驶服务',
        kindCode: '030136',
        kindInd: '2',
        relatedInd: '0',
        quantity: 1, //次数
        sumInsured: '0',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    {
        /* 代为送检服务特约 */
        name: '代为送检险',
        kindCode: '030137',
        kindInd: '2',
        relatedInd: '0',
        quantity: 1,
        sumInsured: '0',
        checked: false,
        disabled: false,
        clauseTypes: '0',
        valueType: '1', // 默认需过线， 0：免过线 1：需过线
    },
    // {
    //     /* 附加发动机进水损坏除外特约  */
    //     name: '发动机进水损坏除外险',
    //     kindCode: '030138',
    //     relatedInd: '0',
    //     sumInsured: '0',
    //     checked: false,
    //     relatedIndChecked: false,
    //     disabled: false,
    //     clauseTypes: '0',
    // },
    {
        /* 车轮单独损坏除外特约 */
        name: '车轮单独损失险',
        kindCode: '030139',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '1000',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    {
        /* 附加医保外医疗费用责任险（三者） */
        name: '医保外医疗费用责任险（三者）',
        kindCode: '030140',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '',
        checked: false,
        disabled: false,
        clauseTypes: '0',
    },
    {
        /* 附加医保外医疗费用责任险（司机） */
        name: '医保外医疗费用责任险（司机）',
        kindCode: '030141',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '',
        quantity: '1',
        unitInsured: '',
        checked: false,
        disabled: false,
        clauseTypes: '0',
    },
    {
        /* 附加医保外医疗费用责任险（乘客） */
        name: '医保外医疗费用责任险（乘客）',
        kindCode: '030142',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '',
        unitInsured: '',
        quantity: '',
        checked: false,
        disabled: false,
        clauseTypes: '0',
    },
    {
        /* 精神损害抚慰金责任险（三者） */
        name: '精神损害抚慰金险（三者）',
        kindCode: '030144',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '',
        checked: false,
        disabled: false,
        clauseTypes: '0',
    },
    {
        /* 精神损害抚慰金责任险（司机） */
        name: '精神损害抚慰金险（司机）',
        kindCode: '030145',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '',
        unitInsured: '',
        quantity: '1',
        checked: false,
        disabled: false,
        clauseTypes: '0',
    },
    {
        /* 精神损害抚慰金责任险（乘客） */
        name: '精神损害抚慰金险（乘客）',
        kindCode: '030146',
        kindInd: '2',
        relatedInd: '0',
        unitInsured: '',
        sumInsured: '',
        quantity: '',
        checked: false,
        disabled: false,
        clauseTypes: '0',
    },
    {
        /* 绝对免赔率特约险（车损） */
        name: '绝对免赔率(车损)',
        kindCode: 'rate030101',
        relatedInd: '0',
        checked: false,
        disabled: false,
        clauseTypes: '0',
        isNoQuote: true,
        rate: '5'
    },
    {
        /* 绝对免赔率特约险（三者） */
        name: '绝对免赔率(三者)',
        kindCode: 'rate030102',
        relatedInd: '0',
        checked: false,
        disabled: false,
        clauseTypes: '0',
        isNoQuote: true,
        rate: '5'
    },
    {
        /* 绝对免赔率特约险（司机） */
        name: '绝对免赔率(司机)',
        kindCode: 'rate030104',
        relatedInd: '0',
        checked: false,
        disabled: false,
        clauseTypes: '0',
        isNoQuote: true,
        rate: '5'
    },
    {
        /* 绝对免赔率特约险（乘客） */
        name: '绝对免赔率(乘客)',
        kindCode: 'rate030105',
        relatedInd: '0',
        checked: false,
        disabled: false,
        clauseTypes: '0',
        isNoQuote: true,
        rate: '5'
    },
    {
        /* 外部电网故障险 */
        name: '外部电网故障险',
        kindCode: '030152',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '',
        unitInsured: '',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    // {
    //     /* 充电桩损失险 */
    //     name: '充电桩损失险',
    //     kindCode: '030153',
    //     kindInd: '2',
    //     relatedInd: '0',
    //     sumInsured: '0',
    //     unitInsured: '2000',
    //     quantity: '0',
    //     checked: false,
    //     relatedIndChecked: false,
    //     disabled: false,
    //     clauseTypes: '0',
    // },
    // {
    //     /* 充电桩责任险 */
    //     name: '充电桩责任险',
    //     kindCode: '030154',
    //     kindInd: '2',
    //     relatedInd: '0',
    //     sumInsured: '0',
    //     unitInsured: '10000',
    //     quantity: '0',
    //     checked: false,
    //     relatedIndChecked: false,
    //     disabled: false,
    //     clauseTypes: '0',
    // },
    // {
    //     /* OTA损失补偿险 */
    //     name: 'OTA损失补偿险',
    //     kindCode: '030155',
    //     kindInd: '2',
    //     relatedInd: '0',
    //     sumInsured: '',
    //     unitInsured: '',
    //     checked: false,
    //     relatedIndChecked: false,
    //     disabled: false,
    //     clauseTypes: '0',
    // },
    // {
    //     /* 火灾事故翻倍险 */
    //     name: '火灾事故翻倍险',
    //     kindCode: '030156',
    //     kindInd: '2',
    //     relatedInd: '0',
    //     sumInsured: '',
    //     quantity: '2', // 倍数
    //     checked: false,
    //     disabled: false,
    //     clauseTypes: '0',
    // },
    {
        /* 绝对免赔率特约险*/
        name: '绝对免赔率特约险',
        deductible: '',
        kindCode: '021',
        kindInd: '2',
        quantity: '',
        relatedInd: '0',
        nonDeductiblePremium: '',
        sumInsured: '',
        unitInsured: '',
        rate: '0',
        valueType: '',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '',
    }
];
// 山东运营车展示险别（新能源）
export const COVERAGE_List_XNY_Sd = [{
        /* 车辆损失保险 */
        name: '车辆损失险', // 险种名称
        deductible: '0', // 免赔额
        deductibleRate: '0', // 绝对免赔率
        nonDeductiblePremium: '', // 免赔率保费
        kindCode: '030101', // 险种代码
        kindInd: '1', // 主险标志
        relatedInd: '0', // 不计免赔
        sumInsured: '', // 险种保额
        renewal: '', // 带出上年险种标识
        checked: false, // 是否选中
        relatedIndChecked: false,
        clauseTypes: '0',
        disabled: false,
    },
    {
        /* 商业第三者责任保险 */
        name: '三者责任险',
        deductibleRate: '0',
        nonDeductiblePremium: '',
        kindCode: '030102',
        kindInd: '1',
        relatedInd: '0',
        sumInsured: '500000',
        checked: false,
        relatedIndChecked: false,
        clauseTypes: '0',
        disabled: false,
    },
    {
        /* 车上人员责任保险（司机）  */
        name: '车上人员（司机）',
        deductibleRate: '0',
        nonDeductiblePremium: '',
        kindCode: '030104',
        kindInd: '1',
        relatedInd: '0',
        sumInsured: '',
        unitInsured: '10000',
        checked: false,
        relatedIndChecked: false,
        clauseTypes: '0',
        disabled: false,
    },
    {
        /* 车上人员责任保险（乘客） */
        name: '车上人员（乘客）',
        deductibleRate: '0',
        nonDeductiblePremium: '',
        kindCode: '030105',
        quantity: '',
        relatedInd: '0',
        sumInsured: '',
        unitInsured: '10000',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    {
        /* 附加医保外医疗费用责任险（三者） */
        name: '医保外医疗费用责任险（三者）',
        kindCode: '030140',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '',
        checked: false,
        disabled: false,
        clauseTypes: '0',
    },
    {
        /* 精神损害抚慰金责任险（三者） */
        name: '精神损害抚慰金险（三者）',
        kindCode: '030144',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '',
        checked: false,
        disabled: false,
        clauseTypes: '0',
    },
    {
        /* 绝对免赔率特约险（车损） */
        name: '绝对免赔率(车损)',
        kindCode: 'rate030101',
        relatedInd: '0',
        checked: false,
        disabled: false,
        clauseTypes: '0',
        isNoQuote: true,
        rate: '5'
    },
    {
        /* 绝对免赔率特约险（三者） */
        name: '绝对免赔率(三者)',
        kindCode: 'rate030102',
        relatedInd: '0',
        checked: false,
        disabled: false,
        clauseTypes: '0',
        isNoQuote: true,
        rate: '5'
    },
    {
        /* 绝对免赔率特约险（司机） */
        name: '绝对免赔率(司机)',
        kindCode: 'rate030104',
        relatedInd: '0',
        checked: false,
        disabled: false,
        clauseTypes: '0',
        isNoQuote: true,
        rate: '5'
    },
    {
        /* 绝对免赔率特约险（乘客） */
        name: '绝对免赔率(乘客)',
        kindCode: 'rate030105',
        relatedInd: '0',
        checked: false,
        disabled: false,
        clauseTypes: '0',
        isNoQuote: true,
        rate: '5'
    },
    {
        /* 绝对免赔率特约险*/
        name: '绝对免赔率特约险',
        deductible: '',
        kindCode: '021',
        kindInd: '2',
        quantity: '',
        relatedInd: '0',
        nonDeductiblePremium: '',
        sumInsured: '',
        unitInsured: '',
        rate: '0',
        valueType: '',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '',
    },
    {
        /* 车辆安全检测特约 */
        name: '车辆安全检测险',
        kindCode: '030135',
        kindInd: '2',
        relatedInd: '0',
        quantity: 1, //次数
        sumInsured: '0',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    {
        /* 代为驾驶服务特约 */
        name: '代为驾驶服务',
        kindCode: '030136',
        kindInd: '2',
        relatedInd: '0',
        quantity: 1, //次数
        sumInsured: '0',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    {
        /* 代为送检服务特约 */
        name: '代为送检险',
        kindCode: '030137',
        kindInd: '2',
        relatedInd: '0',
        quantity: 1,
        sumInsured: '0',
        checked: false,
        disabled: false,
        clauseTypes: '0',
        valueType: '1', // 默认需过线， 0：免过线 1：需过线
    },
];

// 商业险险种  coverageList
export const COVERAGE_OBJECT = {
    '030101': {
        /* 车辆损失保险 */
        deductible: '', // 免赔额
        deductibleRate: '0', // 绝对免赔率
        nonDeductiblePremium: '', // 免赔率保费
        kindCode: '030101', // 险种代码
        kindInd: '1', // 主险标志
        relatedInd: '0', // 不计免赔
        sumInsured: '', // 险种保额
        renewal: '', // 带出上年险种标识
        checked: false, // 是否选中
        relatedIndChecked: false,
        clauseTypes: '0',
        disabled: false,
    },
    '030102': {
        /* 商业第三者责任保险 */
        deductibleRate: '0',
        nonDeductiblePremium: '',
        kindCode: '030102',
        kindInd: '1',
        relatedInd: '0',
        sumInsured: '500000',
        checked: false,
        relatedIndChecked: false,
        clauseTypes: '0',
        disabled: false,
    },
    '030104': {
        /* 车上人员责任保险（司机）  */
        deductibleRate: '0',
        nonDeductiblePremium: '',
        kindCode: '030104',
        kindInd: '1',
        relatedInd: '0',
        sumInsured: '',
        unitInsured: '10000',
        checked: false,
        relatedIndChecked: false,
        clauseTypes: '0',
        disabled: false,
    },
    '030105': {
        /* 车上人员责任保险（乘客） */
        deductibleRate: '0',
        nonDeductiblePremium: '',
        kindCode: '030105',
        quantity: '',
        relatedInd: '0',
        sumInsured: '',
        unitInsured: '10000',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    '021': {
        /* 绝对免赔率特约险*/
        deductible: '',
        kindCode: '021',
        kindInd: '2',
        quantity: '',
        relatedInd: '0',
        nonDeductiblePremium: '',
        sumInsured: '',
        unitInsured: '',
        rate: '0',
        valueType: '',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '',
    },
    '030110': {
        /* 车身划痕损失险 */
        kindCode: '030110',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '2000',
        unitInsured: '',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    '030138': {
        /* 附加发动机进水损坏除外特约  */
        kindCode: '030138',
        relatedInd: '0',
        sumInsured: '0',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    '030112': {
        /* 修理期间费用补偿险  */
        kindCode: '030112',
        quantity: 20,
        relatedInd: '0',
        sumInsured: '',
        unitInsured: '20',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    '030120': {
        /* 三者假日翻倍险  */
        kindCode: '030120',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '500000',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    '030139': {
        /* 车轮单独损坏除外特约 */
        kindCode: '030139',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '1000',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    '030124': {
        /* 保险人指定修理厂特约 */
        kindCode: '030124',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '0',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    '030134': {
        /* 道路救援服务特约 */
        kindCode: '030134',
        kindInd: '2',
        relatedInd: '0',
        quantity: '2', //次数
        sumInsured: '0',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    '030135': {
        /* 车辆安全检测特约 */
        kindCode: '030135',
        kindInd: '2',
        relatedInd: '0',
        quantity: 1, //次数
        sumInsured: '0',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    '030136': {
        /* 代为驾驶服务特约 */
        kindCode: '030136',
        kindInd: '2',
        relatedInd: '0',
        quantity: 1, //次数
        sumInsured: '0',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    '030137': {
        /* 代为送检服务特约 */
        kindCode: '030137',
        kindInd: '2',
        relatedInd: '0',
        quantity: 1,
        sumInsured: '0',
        checked: false,
        disabled: false,
        clauseTypes: '0',
    },
    '030140': {
        /* 附加医保外医疗费用责任险（三者） */
        kindCode: '030140',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '',
        checked: false,
        disabled: false,
        clauseTypes: '0',
    },
    '030141': {
        /* 附加医保外医疗费用责任险（司机） */
        kindCode: '030141',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '',
        quantity: '1',
        unitInsured: '',
        checked: false,
        disabled: false,
        clauseTypes: '0',
    },
    '030142': {
        /* 附加医保外医疗费用责任险（乘客） */
        kindCode: '030142',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '',
        unitInsured: '',
        quantity: '',
        checked: false,
        disabled: false,
        clauseTypes: '0',
    },
    '030144': {
        /* 精神损害抚慰金责任险（三者） */
        kindCode: '030144',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '',
        checked: false,
        disabled: false,
        clauseTypes: '0',
    },
    '030145': {
        /* 精神损害抚慰金责任险（司机） */
        kindCode: '030145',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '',
        unitInsured: '',
        quantity: '1',
        checked: false,
        disabled: false,
        clauseTypes: '0',
    },
    '030146': {
        /* 精神损害抚慰金责任险（乘客） */
        kindCode: '030146',
        kindInd: '2',
        relatedInd: '0',
        unitInsured: '',
        sumInsured: '',
        quantity: '',
        checked: false,
        disabled: false,
        clauseTypes: '0',
    },
    'rate030101': {
        /* 绝对免赔率特约险（车损） */
        name: '绝对免赔率(车损)',
        kindCode: 'rate030101',
        relatedInd: '0',
        checked: false,
        disabled: false,
        clauseTypes: '0',
        isNoQuote: true,
        rate: '5'
    },
    'rate030102': {
        /* 绝对免赔率特约险（三者） */
        name: '绝对免赔率(三者)',
        kindCode: 'rate030102',
        relatedInd: '0',
        checked: false,
        disabled: false,
        clauseTypes: '0',
        isNoQuote: true,
        rate: '5'
    },
    'rate030104': {
        /* 绝对免赔率特约险（司机） */
        name: '绝对免赔率(司机)',
        kindCode: 'rate030104',
        relatedInd: '0',
        checked: false,
        disabled: false,
        clauseTypes: '0',
        isNoQuote: true,
        rate: '5'
    },
    'rate030105': {
        /* 绝对免赔率特约险（乘客） */
        name: '绝对免赔率(乘客)',
        kindCode: 'rate030105',
        relatedInd: '0',
        checked: false,
        disabled: false,
        clauseTypes: '0',
        isNoQuote: true,
        rate: '5'
    },
    '021': {
        /* 绝对免赔率特约险*/
        name: '绝对免赔率特约险',
        deductible: '',
        kindCode: '021',
        kindInd: '2',
        quantity: '',
        relatedInd: '0',
        nonDeductiblePremium: '',
        sumInsured: '',
        unitInsured: '',
        rate: '0',
        valueType: '',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '',
    }
};

// TODO 新能源险种  coverageList
export const COVERAGE_OBJECT_XNY = {
    '030101': {
        /* 车辆损失保险 */
        deductible: '', // 免赔额
        deductibleRate: '0', // 绝对免赔率
        nonDeductiblePremium: '', // 免赔率保费
        kindCode: '030101', // 险种代码
        kindInd: '1', // 主险标志
        relatedInd: '0', // 不计免赔
        sumInsured: '', // 险种保额
        renewal: '', // 带出上年险种标识
        checked: false, // 是否选中
        relatedIndChecked: false,
        clauseTypes: '0',
        disabled: false,
    },
    '030102': {
        /* 商业第三者责任保险 */
        deductibleRate: '0',
        nonDeductiblePremium: '',
        kindCode: '030102',
        kindInd: '1',
        relatedInd: '0',
        sumInsured: '500000',
        checked: false,
        relatedIndChecked: false,
        clauseTypes: '0',
        disabled: false,
    },
    '030104': {
        /* 车上人员责任保险（司机）  */
        deductibleRate: '0',
        nonDeductiblePremium: '',
        kindCode: '030104',
        kindInd: '1',
        relatedInd: '0',
        sumInsured: '',
        unitInsured: '10000',
        checked: false,
        relatedIndChecked: false,
        clauseTypes: '0',
        disabled: false,
    },
    '030105': {
        /* 车上人员责任保险（乘客） */
        deductibleRate: '0',
        nonDeductiblePremium: '',
        kindCode: '030105',
        quantity: '',
        relatedInd: '0',
        sumInsured: '',
        unitInsured: '10000',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    '021': {
        /* 绝对免赔率特约险*/
        deductible: '',
        kindCode: '021',
        kindInd: '2',
        quantity: '',
        relatedInd: '0',
        nonDeductiblePremium: '',
        sumInsured: '',
        unitInsured: '',
        rate: '0',
        valueType: '',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '',
    },
    '030110': {
        /* 车身划痕损失险 */
        kindCode: '030110',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '2000',
        unitInsured: '',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    '030138': {
        /* 附加发动机进水损坏除外特约  */
        kindCode: '030138',
        relatedInd: '0',
        sumInsured: '0',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    '030112': {
        /* 修理期间费用补偿险  */
        kindCode: '030112',
        quantity: 20,
        relatedInd: '0',
        sumInsured: '',
        unitInsured: '20',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    '030120': {
        /* 三者假日翻倍险  */
        kindCode: '030120',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '500000',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    '030139': {
        /* 车轮单独损坏除外特约 */
        kindCode: '030139',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '1000',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    '030124': {
        /* 保险人指定修理厂特约 */
        kindCode: '030124',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '0',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    '030134': {
        /* 道路救援服务特约 */
        kindCode: '030134',
        kindInd: '2',
        relatedInd: '0',
        quantity: '2', //次数
        sumInsured: '0',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    '030135': {
        /* 车辆安全检测特约 */
        kindCode: '030135',
        kindInd: '2',
        relatedInd: '0',
        quantity: 1, //次数
        sumInsured: '0',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    '030136': {
        /* 代为驾驶服务特约 */
        kindCode: '030136',
        kindInd: '2',
        relatedInd: '0',
        quantity: 1, //次数
        sumInsured: '0',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    '030137': {
        /* 代为送检服务特约 */
        kindCode: '030137',
        kindInd: '2',
        relatedInd: '0',
        quantity: 1,
        sumInsured: '0',
        checked: false,
        disabled: false,
        clauseTypes: '0',
    },
    '030140': {
        /* 附加医保外医疗费用责任险（三者） */
        kindCode: '030140',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '',
        checked: false,
        disabled: false,
        clauseTypes: '0',
    },
    '030141': {
        /* 附加医保外医疗费用责任险（司机） */
        kindCode: '030141',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '',
        quantity: '1',
        unitInsured: '',
        checked: false,
        disabled: false,
        clauseTypes: '0',
    },
    '030142': {
        /* 附加医保外医疗费用责任险（乘客） */
        kindCode: '030142',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '',
        unitInsured: '',
        quantity: '',
        checked: false,
        disabled: false,
        clauseTypes: '0',
    },
    '030144': {
        /* 精神损害抚慰金责任险（三者） */
        kindCode: '030144',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '',
        checked: false,
        disabled: false,
        clauseTypes: '0',
    },
    '030145': {
        /* 精神损害抚慰金责任险（司机） */
        kindCode: '030145',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '',
        unitInsured: '',
        quantity: '1',
        checked: false,
        disabled: false,
        clauseTypes: '0',
    },
    '030146': {
        /* 精神损害抚慰金责任险（乘客） */
        kindCode: '030146',
        kindInd: '2',
        relatedInd: '0',
        unitInsured: '',
        sumInsured: '',
        quantity: '',
        checked: false,
        disabled: false,
        clauseTypes: '0',
    },
    'rate030101': {
        /* 绝对免赔率特约险（车损） */
        name: '绝对免赔率(车损)',
        kindCode: 'rate030101',
        relatedInd: '0',
        checked: false,
        disabled: false,
        clauseTypes: '0',
        isNoQuote: true,
        rate: '5'
    },
    'rate030102': {
        /* 绝对免赔率特约险（三者） */
        name: '绝对免赔率(三者)',
        kindCode: 'rate030102',
        relatedInd: '0',
        checked: false,
        disabled: false,
        clauseTypes: '0',
        isNoQuote: true,
        rate: '5'
    },
    'rate030104': {
        /* 绝对免赔率特约险（司机） */
        name: '绝对免赔率(司机)',
        kindCode: 'rate030104',
        relatedInd: '0',
        checked: false,
        disabled: false,
        clauseTypes: '0',
        isNoQuote: true,
        rate: '5'
    },
    'rate030105': {
        /* 绝对免赔率特约险（乘客） */
        name: '绝对免赔率(乘客)',
        kindCode: 'rate030105',
        relatedInd: '0',
        checked: false,
        disabled: false,
        clauseTypes: '0',
        isNoQuote: true,
        rate: '5'
    },
    '030152': {
        /* 外部电网故障险 */
        kindCode: '030152',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '',
        unitInsured: '',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    '030153': {
        /* 充电桩损失险 */
        kindCode: '030153',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '2000',
        unitInsured: '',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    '030154': {
        /* 充电桩责任险 */
        kindCode: '030154',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '0',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    '030155': {
        /* OTA损失补偿险 */
        kindCode: '030155',
        kindInd: '2',
        relatedInd: '0',
        sumInsured: '',
        unitInsured: '',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    '030156': {
        /* 火灾事故翻倍险 */
        kindCode: '030156',
        kindInd: '2',
        relatedInd: '0',
        quantity: '2', //次数
        sumInsured: '',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '0',
    },
    '021': {
        /* 绝对免赔率特约险*/
        name: '绝对免赔率特约险',
        deductible: '',
        kindCode: '021',
        kindInd: '2',
        quantity: '',
        relatedInd: '0',
        nonDeductiblePremium: '',
        sumInsured: '',
        unitInsured: '',
        rate: '0',
        valueType: '',
        checked: false,
        relatedIndChecked: false,
        disabled: false,
        clauseTypes: '',
    }
};

// 商业险其他信息
export const SY_RISK = {
    "coverageList": [],
    "effectFlag": "1", //即时生效 非即时：0,即时：1
    "endDate": "",
    "riskCode": "0312",
    "startDate": "",
}

// TODO 新能源其他信息
export const XNY_RISK = {
    "coverageList": [],
    "effectFlag": "1", //即时生效 非即时：0,即时：1
    "endDate": "",
    "riskCode": "0317",
    "startDate": "",
};

// 交强险
export const JQ_RISK = {
    "coverageList": [{
        "kindCode": "BZ",
        "kindInd": "1",
        "sumInsured": 200000
    }],
    "effectFlag": "0", //即时生效 非即时：0,即时：1
    "riskCode": "0301",
    "startDate": "",
    "sumGrossPremium": '',
    "proposalNo": "",
    "vhlTax": {
        "certiType": "",
        "deductionDueType": "", //	减免税方案
        "fuelType": "0",
        "identifyNumber": "",
        "paidFreeCertificate": "",
        "relifReason": "7", //减免税原因
        "taxCompancyCode": "",
        "taxCompancyName": "",
        "taxItemDetailCode": "",
        "taxPayerName": "",
        "taxRelifFlag": "",
        "taxpayerIdentifier": ""
    }
}

export const BASE_BEAN = {
    // 充电桩种类
    CHARGE_PILE_TYPE: {
        "1": "地面充电桩",
        "2": "壁挂式充电桩",
        "3": "其他类型充电桩",
    },
    // 安装地点
    INSTALL_SITE: {
        "101": "地面停车场",
        "102": "地面停车楼",
        "103": "地下停车场",
        "201": "地面停车场",
        "202": "地面停车楼",
        "203": "地下停车场",
        "301": "地面停车场",
        "302": "地面停车楼",
        "303": "地下停车场",
    },
    popoverItems: {
        '0': '车险业绩',
        '1': '全民优保业绩',
        '2': '全部业绩',
    },
    underWriteState: {
        '0': '初始状态',
        '1': '人工核保通过',
        '2': '下发修改',
        '3': '自动核保通过',
        '4': '拒保',
        '6': '承保确认',
        '9': '转人工核保',
    },
    //座位数
    SITE_NUM: ['2', '3', '4', '5', '6', '7', '8'],
    //险种代码 对应中文名称
    INS_CN_NAME: {
        '030101': '车辆损失险',
        '030102': '第三者责任险',
        '030103': '全车盗抢险',
        '030104': '车上人员.司机',
        '030105': '车上人员.乘客',
        '030107': '玻璃破碎险',
        '030108': '自燃损失险',
        '030109': '新增设备损失险',
        '030110': '划痕险',
        '030111': '发动机涉水险',
        '030112': '修理期间补偿险',
        '030113': '车上货物责任险',
        '030114': '精神损害责任险',
        '030115': '无法找到第三方',
        '030116': '指定修理厂',
        '030119': '不计免赔率险',
        '030120': '三者假日翻倍险',
    },
    GLASS_TYPY: {
        1: '国产玻璃',
        2: '进口玻璃',
    },
    /* 免赔额选择框 */
    DUDUCTIBLE_VAL: {
        0: 0,
        300: 300,
        500: 500,
        1000: 1000,
        2000: 2000,
    },
    /* 免赔率选择框 */
    DUDUCTIBLE_RATE: {
        0: 0,
        5: 5,
        10: 10,
        15: 15,
        20: 20,
    },
    /* 道路救援 */
    DAOLU_VAL: {
        2: '赠送2次',
        7: '7次(含赠送2次)',
        12: '12次(含赠送2次)',
        17: '17次(含赠送2次)',
        22: '22次(含赠送2次)',
    },
    /*商业第三者责任险选择框*/
    LIABILITY_INS_VAL: {
        100000: '10万',
        150000: '15万',
        200000: '20万',
        300000: '30万',
        500000: '50万',
        1000000: '100万',
        1500000: '150万',
        2000000: '200万',
        2500000: '250万',
        3000000: '300万',
        3500000: '350万',
        4000000: '400万',
        4500000: '450万',
        5000000: '500万',
        10000000: '1000万',
    },
    //司机座位险
    DRIVER_SEAT: {
        5000: '0.5万',
        10000: '1万',
        20000: '2万',
        30000: '3万',
        40000: '4万',
        50000: '5万',
        100000: '10万',
        150000: '15万',
        200000: '20万',
        300000: '30万',
    },
    //乘客座位险
    PASSENGER_SEAT: {
        5000: '0.5万',
        10000: '1万',
        20000: '2万',
        30000: '3万',
        40000: '4万',
        50000: '5万',
        100000: '10万',
        150000: '15万',
        200000: '20万',
        300000: '30万',
    },
    //刮痕险
    SCRATCH_INS: {
        2000: '0.2万',
        5000: '0.5万',
        10000: '1万',
        20000: '2万',
    },
    //修理期间费用补偿险
    COST_COM: {
        ROWS_NAME: '天',
        ITEMS_NAME: '元/天',
        ROWS: [20, 50, 90],
        ITEMS: [20, 50, 100, 200, 500],
    },
    //精神损害抚慰金责任险
    SPIR_COMFORT: {
        10000: '1万',
        20000: '2万',
        30000: '3万',
        40000: '4万',
        50000: '5万',
        100000: '10万',
        150000: '15万',
        200000: '20万',
    },
    //支付状态
    PAY_STATUS: {
        '-2': '未付款',
        '-1': '未付款',
        '0': '未付款',
        '1': '已付款',
        '5': '已付款',
    },
    //险别
    INSURANCE_VARIETY: {
        '0301': '交强险',
        '0312': '商业险',
        '0317': '新能源',
    },
    //核保状态
    CKECK_STATUS: {
        '0': '未核保',
        '1': '已核保',
        '3': '打回修改',
        '5': '总公司核保',
        '7': '预核保',
    },
    PAY_STATE: {
        '1': '已支付',
        '2': '待支付',
        '3': '待修改',
        '4': '待审核',
    },
    PAY_STATES: {
        '1': '支付未出单',
        '2': '待支付',
        '3': '待修改',
        '4': '待审核',
    },
    IMG_STATE: {
        '1': '已上传,可继续补传',
        '0': '未上传',
    },
    IMG_REV: {
        '0': '规则异常',
        '1': '事前复核',
        '11': '事前复核已提交',
        '1_0': '事前复核通过',
        '1_9': '事前复核不通过',
        '2': '事后复核',
        '21': '事后复核已提交',
        '2_1': '事后复核转事前复核',
        '2_2': '事后复核转事前复核已提交',
        '2_1_0': '事后复核转事前复核通过',
        '2_1_9': '事后复核转事前复核不通过',
        '3': '无需复核',
    },
    //影像状态
    IMG_STATUS: {
        '010001': '未上传',
        '010002': '补传中',
        '010003': '申请中',
        '010004': '已完成',
    },
    //车辆来历凭证种类
    CERTIFICATE_TYPES: {
        '01': '销售发票',
        '02': '法院调解书',
        '03': '法院规定书',
        '04': '法院判决书',
        '05': '仲裁裁决书',
        '06': '相关文书(继承、赠予、协议抵债)',
        '07': '批准文件',
        '08': '调拨证明',
        '09': '修理发票',
    },
    //减免税标识
    TAX_TYPES: {
        '922001': '纳税',
        '922002': '减税',
        '922003': '免税',
        '922004': '完税',
    },
    //减免税日期分割线
    TAX_TIME_DIVISION: '2015-09-11',

    //主险和附加险的对应关系
    CS_FJINS: ['030107', '030108', '030110', '030109', '030111', '030112', '030115', '030116'], //车辆损失险的附加险

    JF_FJINS: ['030114'],

    //醉酒后驾驶违法行为系数
    DRINK_DICTIONARY: {
        '936001': '零次',
        '936002': '一次',
        '936003': '两次',
        '936004': '三次及以上',
    },
    // 保单样式
    POLICY_STYLES: {
        "0": "纸质保单",
        "1": "电子保单",
        "2": "华安电子保单",
    },
    // 发票信息
    INVTYPE: {
        "0": "普通发票",
        //"1": "专用发票",
        "2": "电子发票",
    },
    // 数电发票信息： 纸质发票、电子发票————数电普票,专用发票————数电专票
    INVTYPE_DIGITAL: {
        "4": "数电普票",
        // "5": "数电专票",
    },
    // 减免税信息
    TAX_RELIF: {
        "01": "不缴纳车船税",
        "02": "帮我缴税",
        "03": "我已经缴税",
        "04": "我享减税政策",
        "05": "我享免税政策",
    },
    // 车船税税务机构选项
    TAX_COMPANY: {
        "10100": "和平地税",
        "10200": "河东地税",
        "10300": "河西地税",
        "10400": "南开地税",
        "22400": "宝坻地税",
        "22500": "蓟县地税",
        "11100": "西青地税",
        "10500": "河北地税",
        "10600": "红桥地税",
        "10700": "塘沽地税",
        "10800": "汉沽地税",
        "10900": "大港地税",
        "11000": "东丽地税",
        "11200": "津南地税",
        "11300": "北辰地税",
        "11400": "直属地税",
        "11500": "开发地税",
        "11600": "保税地税",
        "11700": "园区地税",
        "11900": "空港地税",
        "22100": "宁河地税",
        "22200": "武清地税",
        "22300": "静海地税"
    },
    // 落户地址
    SETTLE_Add: {
        '10100': '和平区',
        '10200': '河东区',
        '10300': '河西区',
        '10400': '南开区',
        '10500': '河北区',
        '10600': '红桥区',
        '10700': '塘沽区',
        '10800': '汉沽区',
        '10900': '大港区',
        '11000': '东丽区',
        '11100': '西青区',
        '11200': '津南区',
        '11300': '北辰区',
        '11400': '直属',
        '11500': '开发区',
        '11600': '保税区',
        '11700': '新技术产业园区',
        '11900': '空港物流区',
        '12000': '滨海新区',
        '22100': '宁河区',
        '22200': '武清区',
        '22300': '静海区',
        '22400': '宝坻区',
        '22500': '蓟县',
        '40100': '外埠',
    },
    //单位性质联动-》车主类别
    NATURE_CATEGORY: {
        '377005': '376003', //个体私营企业-》企业
        '377006': '376003', //其他企业-》企业
        '377099': '376001', //其他-》个人
    },
    //车主类别-》所属性质
    CAR_TYPE: {
        '376001': '343002', //个体私营企业-》企业
        '376002': '343004', //其他企业-》企业
        '376003': '343003', //其他-》个人
    },
    //所属性质与车主类别转换
    DRVOWNER_CHANGE: {
        '343002': '376001', //个人
        '343003': '376003', //企业
        '343004': '376002', //机关
    },
    //所属性质转投保人类型
    BELOG_TYPES: {
        '01': '1', //个人
        '02': '2', //机关
        '03': '3', //企业
    },
    //车主类别-》所属性质
    DRVOWNER_STYLES: {
        '376001': '个人', //个体私营企业-》企业
        '376002': '机关', //其他企业-》企业
        '376003': '企业', //其他-》个人
    },
    //单保责任类  责任类险种
    DUTY_LIST: ['030102', '030104', '030105', '030114'],

    //与道路交通事故相联系的浮动比率
    ROAD_RATE: {
        A0: '交强险交通事故费率不浮动',
        A1: '上一个年度未发生有责任道路交通事故',
        A2: '上两个年度未发生有责任道路交通事故',
        A3: '上三个及以上年度未发生有责任道路交通事故',
        A4: '上一个年度发生一次有责任不涉及死亡的道路交通事故',
        A5: '上一个年度发生两次及两次以上有责任道路交通事故',
        A6: '上一个年度发生有责任道路交通死亡事故',
    },
    TRAFFIC_RATE: {
        V0: 'V0交强险交通安全违法行为不浮动',
        V1: 'V1上一个年度没有道路交通安全违法行为',
        V2: 'V2上两个年度没有道路交通安全违法行为',
        V3: 'V3上三个及以上年度没有道路交通安全违法行为',
        V4: 'V4上一个年度有道路交通安全违法行为但不属于V5－V7的',
        V5a: 'V5a上一个年度一次违法道路交通信号灯通行的；逆向行驶的',
        V5b: 'V5b上一个年度两次违法道路交通信号灯通行的；逆向行驶的',
        V5c: 'V5c上一个年度三次以及三次以上违法道路交通信号灯通行的；逆向行驶的',
        V6: 'V6上一个年度发生驾驶与准驾车型不符的机动车的；发生机动车驾驶证被暂扣期间驾驶机动车的',
        V7: 'V7上一个年度发生饮酒（含酒精）后驾驶机动车',
        V8: 'V8上一个年度发生各类道路交通违法行为（除V5－V7）五次（含）以上',
    },
    //jqxClassId 转 carKindCodeShow
    CLASSIDTOCARKINDSHOW: {
        "KA": "11", //六座以下客车
        "KB": "12", //六座至十座以下客车
        "KC": "13", //十座至二十座以下客车
        "KD": "14", //二十座至三十六座以下客车
        "KE": "15", //三十六座及三十六座以上客车
        "HA": "21", //二吨以下货车
        "HB": "22", //二吨至五吨以下货车
        "HC": "23", //五吨至十吨以下货车
        "HD": "24", //十吨以上货车
        "GA": "25", //二吨以下挂车
        "GB": "26", //二吨至五吨以下挂车
        "GC": "27", //五吨至十吨以下挂车
        "GD": "28" //十吨以上挂车
    },
    CAR_LOGO: {
        '奥迪': require('../assets/logos/奥迪.jpg'),
        '宝马': require('../assets/logos/宝马.jpg'),
        '奔驰': require('../assets/logos/奔驰.jpg'),
        '奔腾': require('../assets/logos/奔腾.jpg'),
        '本田': require('../assets/logos/本田.jpg'),
        '比亚迪': require('../assets/logos/比亚迪.jpg'),
        '标致': require('../assets/logos/标致.jpg'),
        '别克': require('../assets/logos/别克.jpg'),
        '大众': require('../assets/logos/大众.jpg'),
        '丰田': require('../assets/logos/丰田.jpg'),
        '福特': require('../assets/logos/福特.jpg'),
        '哈飞': require('../assets/logos/哈飞.jpg'),
        '雷诺': require('../assets/logos/雷诺.jpg'),
        '铃木': require('../assets/logos/铃木.jpg'),
        '马自达': require('../assets/logos/马自达.jpg'),
        '名爵': require('../assets/logos/名爵.jpg'),
        '奇瑞': require('../assets/logos/奇瑞.jpg'),
        '启辰': require('../assets/logos/启辰.jpg'),
        '起亚': require('../assets/logos/起亚.jpg'),
        '日产': require('../assets/logos/日产.jpg'),
        '荣威': require('../assets/logos/荣威.jpg'),
        '三菱': require('../assets/logos/三菱.jpg'),
        '斯柯达': require('../assets/logos/斯柯达.jpg'),
        '现代': require('../assets/logos/现代.jpg'),
        '雪佛兰': require('../assets/logos/雪佛兰.jpg'),
        '雪铁龙': require('../assets/logos/雪铁龙.jpg'),
        '长城': require('../assets/logos/长城.jpg'),
        '中华': require('../assets/logos/中华.jpg'),
        '众泰': require('../assets/logos/众泰.jpg'),
        'default': require('../assets/car.png')
    }
};

export const CAR_BEANS = {
    "appConfig": {
        "electronicPolicyFlag": "0", //华安电子保单 0-监制保单  1-电子保单
    },
    "base": {
        "newInsuranceFlag": "1", //新旧保单标志
        "agreementNo": "", //渠道协议
        "agricultureFlag": "", //涉农标志 1：涉农 0：不涉农
        "argueSolution": "", //争议处理方式  1-诉讼 2-仲裁
        "baoHeFlag": "", //报核一体标志  	0 非报核一体；1 报核一体
        "busiAttrConfig": {
            "attachNatures": "01", //所属性质  01个人 02机关/团体 03企业
            "policyStyles": "", // (保单样式, 2华安电子保单,1电子保单 0监制保单)//wll 修改
            "useNatures": "02" //使用性质 01营业 02非营业 03营业出租租赁 04营业城市公交 05营业公路客车
        },
        "businessLevelType": "01", // 业务等级 01一类业务 02二类业务 03三类业务 04四类业务
        "businessStyle": "", //业务类型  01优质业务(A类)  02普通业务(B类)  03高风险业务(C类)  04劣质业务(D类)
        "channel": "", //渠道来源
        "businessSource": "", //渠道代码
        "cityCode": "", //出单机构所在城市
        "companyCode": "", //机构代码
        "companyName": "", //机构名称
        "cooperateName": "", //协作人名称
        "cooperateCode": "", //协作人代码
        "cooperateChannel": "", //协作部门
        "interSalesmanName": "", //经办人名称
        "interSalesmanCode": "", //经办人代码
        "interSalesmanLicense": "", //经办人id
        "cooperateSiteCode": "", //合作网点代码
        "cooperateSiteName": "", //合作网点名称
        "outerCompanyCode": "", //渠道网点代码
        "outerCompanyName": "", //渠道网点名称
        "countryCode": "", //出单机构所在区县
        "handleText": "", // 险种上报说明
        "insuredProduct": "0", // 投保产品 0机动车 1摩托车 3新能源
        "intermediaryCode": "", //代理人编码
        "intermediaryName": "", // 代理人名称
        "joinFlag": "1", //交商同保标志 0-否；1-是
        "operatorCode": "", //出单员代码
        "operatorName": "", // 	出单员名称
        "origSys": "", //系统来源（APP/人人团）
        "outerSystem": "", //系统编码 eshopauto
        "postCode": "", //机构代码对应邮编
        "provinceCode": "", //出单机构所在省份
        "renewInd": "", // 	续保标志 0非续保 1续保
        "salesmanCode": "", //业务员编码
        "salesmanName": "", //业务员名称
        "terminalSource": "", // 终端来源  0104 H5 0106 App
        "frmNoFlag": "", // 新车免两号  真假两号标志
    },
    "owner": {
        "address": "", //地址
        "age": "", //年龄
        "birthday": "",
        "fleetFlg": "",
        "gender": "01", //性别 01男 02女
        "email": "", //邮箱
        "groupCode": "", //团单编码
        "identifyNumber": "", //证件号码
        "identifyType": "01", //证件类型 01	身份证
        "insuredTypeCode": "1", // 车主类别 1个人 2机关 3企业
        "mobilePhone": "", //手机号
        "name": "", //车主名称
        "identifyExpiry": '', // 证件有效期
        "country": "1010090156", // 国籍默认中国
        "occupationCode": "", //客户职业编码
        "occupationName": "", //客户职业名称
        "ownerProvinceCode": "", //行驶证省份
        "ownerCityCode": "", //行驶证市
        "ownerDistrictCode": "", //行驶证区县
        "ownerAddress": "" //行驶证详址
    },
    "applicant": {
        "account": "", //投保人银行
        "address": "", //地址
        "age": "", //年龄
        "birthday": "",
        "email": "",
        "gender": "", //性别 01男 02女
        "identifyNumber": "", //证件号码
        "identifyType": "01", //证件类型
        "insuredType": "", // 投保人类型 1个人 2团体
        "invtype": "", //发票信息  0-普通发票；1-专用发票；2-电子发票
        "isEnterprise": "", //是否企业
        "name": "", //名称
        "openBank": "", //投保人开户银行
        "phone": "", //手机
        "taxType": "03", //纳税人类型   01-一般纳税人;02-小规模纳税人;03-个人
        "mobilePhone": "", // 电子发票联系电话
        "elecproposal": "", //电子保单 北京特有 1-电子投保单 0-普通投保单
        "nation": "", //民族  北京机构
        "issuserCode": "", //签发机构  北京机构
        "certiStartDate": "", //身份证起期  北京机构
        "certiEndDate": "", //身份证止期  北京机构
        "contactName": "", //经办人名称(深圳团单必传)
        "contactMobile": "", //经办人手机号(深圳团单必传)
        "contactIdType": "01", //经办人证件类型(深圳团单必传)
        "contactIdNumber": "", //经办人证件号码(深圳团单必传),
        "identifyExpiry": '', // 证件有效期
        "country": "1010090156", // 国籍默认中国
        "occupationCode": "", //客户职业编码
        "occupationName": "" //客户职业名称
    },
    "insured": {
        "account": "", //被保人银行
        "address": "", //地址
        "age": "", //年龄
        "birthday": "",
        "email": "",
        "gender": "", //性别 01男 02女
        "identifyNumber": "", //证件号码
        "identifyType": "01", //证件类型
        "insuredType": "", // 被保人类型 1个人 2团体
        "name": "", //名称
        "openBank": "", //被保人开户银行
        "phone": "", //手机
        "taxType": "03", //纳税人类型  01-一般纳税人;02-小规模纳税人;03-个人
        "nation": "", //民族  北京机构
        "issuserCode": "", //签发机构  北京机构
        "certiStartDate": "", //身份证起期  北京机构
        "certiEndDate": "", //身份证止期  北京机构,
        "identifyExpiry": '', // 证件有效期
        "country": "1010090156", // 国籍默认中国
        "occupationCode": "", //客户职业编码
        "occupationName": "" //客户职业名称
    },
    "riskList": [],
    "refereeId": "", //人人团推荐人id
    "vehicle": {
        "actualValue": "0", //车辆实际价格
        "attachNature": "01", //所属性质01个人 02机关/团体 03企业
        "blockCode": "", //	街区代码
        "brandName": "", //	厂牌型号
        "carCheckDesc": "", //验车记录
        "carCheckResult": "", //验车结果
        "carChecker": "", //验车人
        "carCheckReason": "", //免验车原因
        "carCheckStatus": "", //验车情况：01已验车 02免验车 03已验车
        "carCheckTime": "", //验车时间
        "carFamilyKind": "", //车系分类
        "carKindCode": "100", //机动车种类 100客车 200货车 300特种车 400摩托车 500拖拉机
        "carKindCodeShow": "", //车辆类型
        "carKindCodeShowName": "", //	车辆类型名称
        "carNewOldFlag": "", //新旧车标志 新车：1、旧车：0
        "carStyle": "",
        "carYear": "", //车辆年份
        "certificateNo": "", // (车辆来历凭证编号)
        "certificateType": "01", //车辆来历凭证编号 01销售发票 02法院调解书 03法院裁定书 04法院判决书 05仲裁裁决书 06相关文书（继承、赠予、协议抵债） 07批准文件 08调拨证明 09修理发票
        "chgOwnerFlag": "", //是否过户车0否 1是
        "networkCar": "", //是否网约车 0否 1是
        "ciCarName": "", //	平台车型名称
        "ciModelCode": "", //	平台车型代码
        "completeKerbMass": "", // 整备质量KG
        //"configModel": "", //配置型号
        "depreciationRate": "", //折旧率
        "engineNo": "", //发动机号
        "maskFrameNo": "", //两号带出的车架号掩码
        "maskEngineNo": "", //两号带出的发动机号掩码
        "exhaustScale": "", //排气量
        "factory": "", //制造厂商
        "familyName": "", //车系名称
        "fleetFlag": "", // 是否车队0否 1是
        "fleetNo": "", // 车队号
        "frameNo": "", //车架号/VIN码
        "fuelFlag": "", //燃油类型0燃油 1纯动机 2燃料电池 3插电式混合动力 4其他混合动力
        "getNewGroupPolicies": "", //获取新团单标识码  	Y是，其他否
        "glassType": "", //玻璃类型01-国产02-进口
        "groupCode": "", //	团单编码
        "hazardType": "", //	风险类型
        "hkFlag": "", //是否粤港两地否-0 是-1
        "imageStatus": "", //验车上传照片状态0未上传1已上传
        "jqxClassId": "", //交强险车辆分类
        "licenseNo": "", //车牌号码
        "loanVehicleFlag": "", //是否按揭车0否 1是
        "localVehicleInd": "", //是否外地车0否 1是
        "modelCode": "", //	厂牌车型代码
        "modelName": "", // 品牌型号
        "printBrandName": "", //打印厂牌车型
        "purchasePrice": "", //新车购置价
        "remark": "", //描述
        "seatCount": "", // 核定载客数
        "series": "",
        "settleAddressCode": "", //车辆落户地址
        "singeinDate": "", //初次登记日期
        "syxClassId": "", //商业险车辆分类
        "useNatureShow": "", //使用性质01营业02非营业03营业出租租赁04营业城市公交05营业公路客运
        "vehicleClass": "", //	车型分类
        "power": "", //功率
        "tonCount": "", //核定载质量
        "chgOwnerDate": "", //转籍过户日期
        "certificateDate": "", //发证日期
        "specialCarFlag": "0", //特殊车辆标志
        "newEnergyFlag": "", // 新能源标志
        "vehicleCategory": "", //交管车辆类型
        "licenseTypeCode": "", //号牌种类
        "licenseColorCode": "", //车牌颜色01蓝02黑03白04黄05白蓝99其他
        "jsQueryFlag": "", //是否查询过江苏交管，防止B2B后台再次查询
        "gdQueryFlag": "", //是否查询过广东交管
        "jgVehicleModel": {}, //交管车型查询缓存
        "vehicleStyleUniqueId": "", // 车型唯一ID
        "vehicleid":"",// 山东营运车专用
        "licenseColorCode": '', // 号牌颜色
        "licenseTypeCode": '', // 号牌类型
        "carColor":'',//车身颜色
    },
    "violationList": null,
    "peopleMarket": { //人人团附加信息
        "businessCode": "HWEB", // 业务来源    string    QMYX: 人人团 HWEB: APP
        "refereeId": "",
        "outDf": "",
        "outUserId": "",
        "issueCode": "", //
        "cooperateCode": "" //客户源
    }
};

export const DEPTCODE = {
    '0100': 'ZONGBU',
    '0101': 'SHENZHEN',
    '0102': 'GUANGDONG',
    '0103': 'HUNAN',
    '0104': 'FUJIAN',
    '0105': 'GUANGXI',
    '0106': 'SHANGHAI',
    '0107': 'BEIJING',
    '0108': 'JIANGSU',
    '0109': 'ZHEJIANG',
    '0110': 'SICHUANG',
    '0111': 'DALIAN',
    '0112': 'SHANDONG',
    '0113': 'CHONGQING',
    '0114': 'YUNNAN',
    '0115': 'SHANXI',
    '0116': 'LIAONING',
    '0117': 'JIANGXI',
    '0118': 'SHANXI',
    '0119': 'TIANJIN',
    '0120': 'ANHUI',
    '0121': 'HUBEI',
    '0122': 'HENAN',
    '0123': 'NINGBO',
    '0125': 'HEBEI',
    '0126': 'HEILONGJIANG',
    '0127': 'JILIN',
    '0128': 'NEIMENGGU',
    '0129': 'GUIZHOU',
    '0130': 'QINGDAO',
    '0131': 'HAINAN',
    '0132': 'GANSU'
}
export const RISK_OPTION = {
    '030102': {
        kindCode: '030102',
        kindCode2CN: '商业第三者责任险',
        premiumList: [{
            name: '10万',
            value: '100000'
        }, {
            name: '15万',
            value: '150000'
        }, {
            name: '20万',
            value: '200000'
        }, {
            name: '30万',
            value: '300000'
        }, {
            name: '50万',
            value: '500000'
        }, {
            name: '100万',
            value: '1000000'
        }, {
            name: '150万',
            value: '1500000'
        }, {
            name: '200万',
            value: '2000000'
        }, {
            name: '250万',
            value: '2500000'
        }, {
            name: '300万',
            value: '3000000'
        }, {
            name: '350万',
            value: '3500000'
        }, {
            name: '400万',
            value: '4000000'
        }, {
            name: '450万',
            value: '4500000'
        }, {
            name: '500万',
            value: '5000000'
        }, {
            name: '1000万',
            value: '10000000'
        }]
    },
    '030104': {
        kindCode: '030104',
        kindCode2CN: '车上人员责任险(司机)',
        premiumList: [{
            name: '0.5万',
            value: '5000'
        }, {
            name: '1万',
            value: '10000'
        }, {
            name: '2万',
            value: '20000'
        }, {
            name: '3万',
            value: '30000'
        }, {
            name: '4万',
            value: '40000'
        }, {
            name: '5万',
            value: '50000'
        }, {
            name: '10万',
            value: '100000'
        }, {
            name: '15万',
            value: '150000'
        }, {
            name: '20万',
            value: '200000'
        }, {
            name: '30万',
            value: '300000'
        }, {
            name: '40万',
            value: '400000'
        }, {
            name: '50万',
            value: '500000'
        }]
    },
    '030105': {
        kindCode: '030105',
        kindCode2CN: '车上人员责任险(乘客)',
        premiumList: [{
            name: '0.5万',
            value: '5000'
        }, {
            name: '1万',
            value: '10000'
        }, {
            name: '2万',
            value: '20000'
        }, {
            name: '3万',
            value: '30000'
        }, {
            name: '4万',
            value: '40000'
        }, {
            name: '5万',
            value: '50000'
        }, {
            name: '10万',
            value: '100000'
        }, {
            name: '15万',
            value: '150000'
        }, {
            name: '20万',
            value: '200000'
        }, {
            name: '30万',
            value: '300000'
        }, {
            name: '40万',
            value: '400000'
        }, {
            name: '50万',
            value: '500000'
        }]
    },
    '030110': {
        kindCode: '030110',
        kindCode2CN: '车身划痕损失险',
        premiumList: [{
            name: '0.2万',
            value: '2000'
        }, {
            name: '0.5万',
            value: '5000'
        }, {
            name: '1万',
            value: '10000'
        }, {
            name: '2万',
            value: '20000'
        }]
    },
    '030112': {
        kindCode: '030112',
        kindCode2CN: '修理期间费用补偿险',
        premiumList: [{
            name: '20元',
            value: '20'
        }, {
            name: '50元',
            value: '50'
        }, {
            name: '100元',
            value: '100'
        }, {
            name: '150元',
            value: '150'
        }, {
            name: '200元',
            value: '200'
        }],
        premiumList2: [{
            name: '20天',
            value: '20'
        }, {
            name: '50天',
            value: '50'
        }, {
            name: '90天',
            value: '90'
        }]
    },
    '030120': {
        kindCode: '030120',
        kindCode2CN: '三者假日翻倍险',
        premiumList: [{
            name: '10万',
            value: '100000'
        }, {
            name: '15万',
            value: '150000'
        }, {
            name: '20万',
            value: '200000'
        }, {
            name: '30万',
            value: '300000'
        }, {
            name: '50万',
            value: '500000'
        }, {
            name: '100万',
            value: '1000000'
        }, {
            name: '150万',
            value: '1500000'
        }, {
            name: '200万',
            value: '2000000'
        }, {
            name: '250万',
            value: '2500000'
        }, {
            name: '300万',
            value: '3000000'
        }, {
            name: '350万',
            value: '3500000'
        }, {
            name: '400万',
            value: '4000000'
        }, {
            name: '450万',
            value: '4500000'
        }, {
            name: '500万',
            value: '5000000'
        }, {
            name: '1000万',
            value: '10000000'
        }]
    },
    '030134': {
        kindCode: '030134',
        kindCode2CN: '道路救援险',
        premiumList: [{
            name: '赠送2次',
            value: '2'
        }, {
            name: '7次(含赠送2次)',
            value: '7'
        }, {
            name: '12次(含赠送2次)',
            value: '12'
        }, {
            name: '17次(含赠送2次)',
            value: '17'
        }, {
            name: '22次(含赠送2次)',
            value: '22'
        }]
    },
    '030139': {
        kindCode: '030139',
        kindCode2CN: '车轮单独损失险',
        premiumList: [{
            name: '1000',
            value: '1000'
        }, {
            name: '2000',
            value: '2000'
        }, {
            name: '3000',
            value: '3000'
        }, {
            name: '5000',
            value: '5000'
        }, {
            name: '10000',
            value: '10000'
        }]
    },
    '030140': {
        kindCode: '030140',
        kindCode2CN: '医保外医疗费用责任险（三者）',
        premiumList: [{
            name: '10万',
            value: '100000'
        }, {
            name: '15万',
            value: '150000'
        }, {
            name: '20万',
            value: '200000'
        }, {
            name: '30万',
            value: '300000'
        }, {
            name: '50万',
            value: '500000'
        }, {
            name: '100万',
            value: '1000000'
        }, {
            name: '150万',
            value: '1500000'
        }, {
            name: '200万',
            value: '2000000'
        }, {
            name: '300万',
            value: '3000000'
        }, {
            name: '400万',
            value: '4000000'
        }, {
            name: '500万',
            value: '5000000'
        }]
    },
    'rate030101': {
        kindCode: 'rate030101',
        kindCode2CN: '绝对免赔率（车损）',
        premiumList: [{
            name: '5%',
            value: '5'
        }, {
            name: '10%',
            value: '10'
        }, {
            name: '15%',
            value: '15'
        }, {
            name: '20%',
            value: '20'
        }]
    },
    'rate030102': {
        kindCode: 'rate030102',
        kindCode2CN: '绝对免赔率（三者）',
        premiumList: [{
            name: '5%',
            value: '5'
        }, {
            name: '10%',
            value: '10'
        }, {
            name: '15%',
            value: '15'
        }, {
            name: '20%',
            value: '20'
        }]
    },
    'rate030104': {
        kindCode: 'rate030104',
        kindCode2CN: '绝对免赔率（司机）',
        premiumList: [{
            name: '5%',
            value: '5'
        }, {
            name: '10%',
            value: '10'
        }, {
            name: '15%',
            value: '15'
        }, {
            name: '20%',
            value: '20'
        }]
    },
    'rate030105': {
        kindCode: 'rate030105',
        kindCode2CN: '绝对免赔率（乘客）',
        premiumList: [{
            name: '5%',
            value: '5'
        }, {
            name: '10%',
            value: '10'
        }, {
            name: '15%',
            value: '15'
        }, {
            name: '20%',
            value: '20'
        }]
    },
    'deductibleList': [{
        name: '0',
        value: '0'
    }, {
        name: '300',
        value: '300'
    }, {
        name: '500',
        value: '500'
    }, {
        name: '1000',
        value: '1000'
    }, {
        name: '2000',
        value: '2000'
    }],
    '03013701':{
        kindCode: '03013701',
        kindCode2CN: '年检状态',
        premiumList: [{
            name: '免过线',
            value: '0'
        }, {
            name: '需过线',
            value: '1'
        }]
    }
};

export const RISK_OPTION_XNY = {
    '030102': {
        kindCode: '030102',
        kindCode2CN: '商业第三者责任险',
        premiumList: [{
            name: '10万',
            value: '100000'
        }, {
            name: '15万',
            value: '150000'
        }, {
            name: '20万',
            value: '200000'
        }, {
            name: '30万',
            value: '300000'
        }, {
            name: '50万',
            value: '500000'
        }, {
            name: '100万',
            value: '1000000'
        }, {
            name: '150万',
            value: '1500000'
        }, {
            name: '200万',
            value: '2000000'
        }, {
            name: '250万',
            value: '2500000'
        }, {
            name: '300万',
            value: '3000000'
        }, {
            name: '350万',
            value: '3500000'
        }, {
            name: '400万',
            value: '4000000'
        }, {
            name: '450万',
            value: '4500000'
        }, {
            name: '500万',
            value: '5000000'
        }, {
            name: '1000万',
            value: '10000000'
        }]
    },
    '030104': {
        kindCode: '030104',
        kindCode2CN: '车上人员责任险(司机)',
        premiumList: [{
            name: '0.5万',
            value: '5000'
        }, {
            name: '1万',
            value: '10000'
        }, {
            name: '2万',
            value: '20000'
        }, {
            name: '3万',
            value: '30000'
        }, {
            name: '4万',
            value: '40000'
        }, {
            name: '5万',
            value: '50000'
        }, {
            name: '10万',
            value: '100000'
        }, {
            name: '15万',
            value: '150000'
        }, {
            name: '20万',
            value: '200000'
        }, {
            name: '30万',
            value: '300000'
        }, {
            name: '40万',
            value: '400000'
        }, {
            name: '50万',
            value: '500000'
        }]
    },
    '030105': {
        kindCode: '030105',
        kindCode2CN: '车上人员责任险(乘客)',
        premiumList: [{
            name: '0.5万',
            value: '5000'
        }, {
            name: '1万',
            value: '10000'
        }, {
            name: '2万',
            value: '20000'
        }, {
            name: '3万',
            value: '30000'
        }, {
            name: '4万',
            value: '40000'
        }, {
            name: '5万',
            value: '50000'
        }, {
            name: '10万',
            value: '100000'
        }, {
            name: '15万',
            value: '150000'
        }, {
            name: '20万',
            value: '200000'
        }, {
            name: '30万',
            value: '300000'
        }, {
            name: '40万',
            value: '400000'
        }, {
            name: '50万',
            value: '500000'
        }]
    },
    '030110': {
        kindCode: '030110',
        kindCode2CN: '车身划痕损失险',
        premiumList: [{
            name: '0.2万',
            value: '2000'
        }, {
            name: '0.5万',
            value: '5000'
        }, {
            name: '1万',
            value: '10000'
        }, {
            name: '2万',
            value: '20000'
        }]
    },
    '030112': {
        kindCode: '030112',
        kindCode2CN: '修理期间费用补偿险',
        premiumList: [{
            name: '20元',
            value: '20'
        }, {
            name: '50元',
            value: '50'
        }, {
            name: '100元',
            value: '100'
        }, {
            name: '150元',
            value: '150'
        }, {
            name: '200元',
            value: '200'
        }],
        premiumList2: [{
            name: '20天',
            value: '20'
        }, {
            name: '50天',
            value: '50'
        }, {
            name: '90天',
            value: '90'
        }]
    },
    '030120': {
        kindCode: '030120',
        kindCode2CN: '三者假日翻倍险',
        premiumList: [{
            name: '10万',
            value: '100000'
        }, {
            name: '15万',
            value: '150000'
        }, {
            name: '20万',
            value: '200000'
        }, {
            name: '30万',
            value: '300000'
        }, {
            name: '50万',
            value: '500000'
        }, {
            name: '100万',
            value: '1000000'
        }, {
            name: '150万',
            value: '1500000'
        }, {
            name: '200万',
            value: '2000000'
        }, {
            name: '250万',
            value: '2500000'
        }, {
            name: '300万',
            value: '3000000'
        }, {
            name: '350万',
            value: '3500000'
        }, {
            name: '400万',
            value: '4000000'
        }, {
            name: '450万',
            value: '4500000'
        }, {
            name: '500万',
            value: '5000000'
        }, {
            name: '1000万',
            value: '10000000'
        }]
    },
    '030134': {
        kindCode: '030134',
        kindCode2CN: '道路救援险',
        premiumList: [{
            name: '赠送2次',
            value: '2'
        }, {
            name: '7次(含赠送2次)',
            value: '7'
        }, {
            name: '12次(含赠送2次)',
            value: '12'
        }, {
            name: '17次(含赠送2次)',
            value: '17'
        }, {
            name: '22次(含赠送2次)',
            value: '22'
        }]
    },
    '030135': {
        kindCode: '030135',
        kindCode2CN: '车辆安全检测险',
        premiumList: [{
            name: '赠送1次',
            value: '1'
        }, {
            name: '2次(含赠送1次)',
            value: '2'
        }, {
            name: '3次(含赠送1次)',
            value: '3'
        }, {
            name: '4次(含赠送1次)',
            value: '4'
        }, {
            name: '5次(含赠送1次)',
            value: '5'
        }, {
            name: '6次(含赠送1次)',
            value: '6'
        }]
    },
    '030136': {
        kindCode: '030136',
        kindCode2CN: '代为驾驶险',
        premiumList: [{
            name: '赠送1次',
            value: '1'
        }, {
            name: '2次(含赠送1次)',
            value: '2'
        }, {
            name: '3次(含赠送1次)',
            value: '3'
        }, {
            name: '4次(含赠送1次)',
            value: '4'
        }, {
            name: '5次(含赠送1次)',
            value: '5'
        }, {
            name: '6次(含赠送1次)',
            value: '6'
        }]
    },
    '030137': {
        kindCode: '030137',
        kindCode2CN: '代为送检险',
        premiumList: [{
            name: '1次',
            value: '1'
        }, {
            name: '2次',
            value: '2'
        }, {
            name: '3次',
            value: '3'
        }, {
            name: '4次',
            value: '4'
        }, {
            name: '5次',
            value: '5'
        }, {
            name: '6次',
            value: '6'
        }]
    },
    '030139': {
        kindCode: '030139',
        kindCode2CN: '车轮单独损失险',
        premiumList: [{
            name: '1000',
            value: '1000'
        }, {
            name: '2000',
            value: '2000'
        }, {
            name: '3000',
            value: '3000'
        }, {
            name: '5000',
            value: '5000'
        }, {
            name: '10000',
            value: '10000'
        }]
    },
    '030140': {
        kindCode: '030140',
        kindCode2CN: '医保外医疗费用责任险（三者）',
        premiumList: [{
            name: '10万',
            value: '100000'
        }, {
            name: '15万',
            value: '150000'
        }, {
            name: '20万',
            value: '200000'
        }, {
            name: '30万',
            value: '300000'
        }, {
            name: '50万',
            value: '500000'
        }, {
            name: '100万',
            value: '1000000'
        }, {
            name: '150万',
            value: '1500000'
        }, {
            name: '200万',
            value: '2000000'
        }, {
            name: '300万',
            value: '3000000'
        }, {
            name: '400万',
            value: '4000000'
        }, {
            name: '500万',
            value: '5000000'
        }]
    },
    'rate030101': {
        kindCode: 'rate030101',
        kindCode2CN: '绝对免赔率（车损）',
        premiumList: [{
            name: '5%',
            value: '5'
        }, {
            name: '10%',
            value: '10'
        }, {
            name: '15%',
            value: '15'
        }, {
            name: '20%',
            value: '20'
        }]
    },
    'rate030102': {
        kindCode: 'rate030102',
        kindCode2CN: '绝对免赔率（三者）',
        premiumList: [{
            name: '5%',
            value: '5'
        }, {
            name: '10%',
            value: '10'
        }, {
            name: '15%',
            value: '15'
        }, {
            name: '20%',
            value: '20'
        }]
    },
    'rate030104': {
        kindCode: 'rate030104',
        kindCode2CN: '绝对免赔率（司机）',
        premiumList: [{
            name: '5%',
            value: '5'
        }, {
            name: '10%',
            value: '10'
        }, {
            name: '15%',
            value: '15'
        }, {
            name: '20%',
            value: '20'
        }]
    },
    'rate030105': {
        kindCode: 'rate030105',
        kindCode2CN: '绝对免赔率（乘客）',
        premiumList: [{
            name: '5%',
            value: '5'
        }, {
            name: '10%',
            value: '10'
        }, {
            name: '15%',
            value: '15'
        }, {
            name: '20%',
            value: '20'
        }]
    },
    'deductibleList': [{
        name: '0',
        value: '0'
    }, {
        name: '300',
        value: '300'
    }, {
        name: '500',
        value: '500'
    }, {
        name: '1000',
        value: '1000'
    }, {
        name: '2000',
        value: '2000'
    }],
    '030153': {
        // 2000元、5000元、10000元或20000元
        kindCode: '030153',
        kindCode2CN: '充电桩损失险',
        premiumList: [{
            name: '0.2万',
            value: '2000'
        }, {
            name: '0.5万',
            value: '5000'
        }, {
            name: '1万',
            value: '10000'
        }, {
            name: '2万',
            value: '20000'
        }]
    },
    '030154': {
        // 1万、2万、3万、5万、10万、20万、30万、50万
        kindCode: '030154',
        kindCode2CN: '充电桩责任险',
        premiumList: [{
            name: '1万',
            value: '10000'
        }, {
            name: '2万',
            value: '20000'
        }, {
            name: '3万',
            value: '30000'
        }, {
            name: '5万',
            value: '50000'
        }, {
            name: '10万',
            value: '100000'
        }, {
            name: '20万',
            value: '200000'
        }, {
            name: '30万',
            value: '300000'
        }, {
            name: '50万',
            value: '500000'
        }]
    },
    '030156': {
        kindCode: '030156',
        kindCode2CN: '火灾事故翻倍险',
        premiumList: [{
            name: '2',
            value: '2'
        }, {
            name: '3',
            value: '3'
        }, {
            name: '4',
            value: '4'
        }]
    },
    '03013701':{
        kindCode: '03013701',
        kindCode2CN: '年检状态',
        premiumList: [{
            name: '免过线',
            value: '0'
        }, {
            name: '需过线',
            value: '1'
        }]
    }
};
export const SALES_AREA = {
    // 销售公司所在地列表
    GUANGDONG: [            
        { value: "440100", name: '广州市' }, { value: "440200", name: '韶关市' },
        { value: "440400", name: '珠海市' }, { value: "440500", name: '汕头市' }, 
        { value: "440600", name: '佛山市' }, { value: "440700", name: '江门市' }, 
        { value: "440800", name: '湛江市' }, { value: "440900", name: '茂名市' }, 
        { value: "441200", name: '肇庆市' }, { value: "441300", name: '惠州市' }, 
        { value: "441400", name: '梅州市' }, { value: "441500", name: '汕尾市' }, 
        { value: "441600", name: '河源市' }, { value: "441700", name: '阳江市' }, 
        { value: "441800", name: '清远市' }, { value: "441900", name: '东莞市' }, 
        { value: "442000", name: '中山市' }, { value: "445100", name: '潮州市' }, 
        { value: "445200", name: '揭阳市' }, { value: "445300", name: '云浮市' }, 
        { value: "999999", name: '其他' }
    ],
}

export const POWER_OPTION = [
    {value: "74", name: "电动摩托车（4kw及以下且车速不大于50km/h）"},
    {value: "75", name: "电动摩托车（4kw以上8KW（含）以下或车速大于50km/h）"},
    {value: "76", name: "电动摩托车（8KW及以上、电动三轮）"}
]

export const CARD_TYPE_OPTION = [
  {
    name: '身份证',
    value: '01'
  },
  {
    name: '外国人永久居留身份证',
    value: '14'
  }
]

export const TD_CARD_TYPE_OPTION = [
  {
    name: '统一社会信用代码',
    value: '09'
  }
]

// 车主类型
export const OWNER_INSURED_TYPE_OPTION = [
  {
    name: '个人',
    value: '1'
  },
  {
    name: '机关',
    value: '2'
  },
  {
    name: '企业',
    value: '3'
  }
]

// 投被保人类型
export const INSURED_TYPE_OPTION = [
  {
    name: '个人',
    value: '1'
  },
  {
    name: '团体',
    value: '2'
  }
]

// 所属性质
export const ATTRACH_OPTION = [
  { 
    name: '个人',
     value: '01'
  },
  {
    name: '机关',
    value: '02'
  },
  {
    name: '企业',
    value: '03'
  }
]

// 自然人、非自然人
export const NEW_ATTRACH_OPTION = [
  { 
    name: '自然人',
     value: '01'
  },
  {
    name: '非自然人',
    value: '02'
  }
]

// 自然人、非自然人
export const NEW_OWNER_OPTION = [
  { 
    name: '自然人',
     value: '1'
  },
  {
    name: '非自然人',
    value: '2'
  }
]
// 使用性质
export const USENATURES_OPTION = [
    { value: "02", name: '非营运' }, { value: "01", name: '营运货车' },
    { value: "03", name: '营业出租',sub:'101'},{ value: "03", name: '租赁',sub:'107' },{ value: "03", name: '预约出租客运',sub:'108' },
    { value: "04", name: '营业城市公交' }, { value: "05", name: '营业公路客运', sub:'109' }, { value: "05", name: '营业旅游客运', sub:'110' }
]

// 车辆类型
export const carKinds = {
    //客车对应座位数，货车挂车对应在质量数范围
    '100': [
      {
        //0<载客数<6
        value: '11',
        limit: [0, 6],
        label: '六座以下客车',
        type: [
          { value: 'K31', label: '小型普通客车' },
          { value: 'K32', label: '小型越野客车' },
          { value: 'K33', label: '轿车' },
          { value: 'K41', label: '微型普通客车' },
          { value: 'K42', label: '微型越野客车' },
          { value: 'K43', label: '微型轿车' }
        ]
      },
      {
        //6<=载客数<10
        value: '12',
        limit: [5, 10],
        label: '六座至十座客车',
        type: [
          { value: 'K31', label: '小型普通客车' },
          { value: 'K32', label: '小型越野客车' },
          { value: 'K33', label: '轿车' },
          { value: 'K41', label: '微型普通客车' },
          { value: 'K42', label: '微型越野客车' },
          { value: 'K43', label: '微型轿车' }
        ]
      },
      {
        //10<=载客数<20
        value: '13',
        limit: [9, 20],
        label: '十座至二十座以下客车',
        type: [
          { value: 'K21', label: '中型普通客车' },
          { value: 'K22', label: '中型双层客车' },
          { value: 'K23', label: '中型卧铺客车' },
          { value: 'K24', label: '中型铰接客车' },
          { value: 'K25', label: '中型越野客车' },
          { value: 'K11', label: '大型普通客车' }
        ]
      },
      {
        //20<=载客数<36
        value: '14',
        limit: [19, 36],
        label: '二十座至三十六座客车',
        type: [
          { value: 'K11', label: '大型普通客车' },
          { value: 'K12', label: '大型双层客车' },
          { value: 'K13', label: '大型卧铺客车' },
          { value: 'K14', label: '大型铰接客车' },
          { value: 'K15', label: '大型越野客车' }
        ]
      },
      {
        //36<=载客数
        value: '15',
        limit: [35, ''],
        label: '三十六座以上客车',
        type: [
          { value: 'K11', label: '大型普通客车' },
          { value: 'K12', label: '大型双层客车' },
          { value: 'K13', label: '大型卧铺客车' },
          { value: 'K14', label: '大型铰接客车' },
          { value: 'K15', label: '大型越野客车' }
        ]
      }
    ],
    '200': [
      {
        //0<核定载质量<2
        value: '21',
        limit: [0, 2],
        label: '二吨以下货车',
        type: [
          { value: 'H21', label: '中型普通货车' },
          { value: 'H22', label: '中型厢式货车' },
          { value: 'H23', label: '中型封闭货车' },
          { value: 'H24', label: '中型罐式货车' },
          { value: 'H25', label: '中型平板货车' },
          { value: 'H26', label: '中型集装厢车' },
          { value: 'H27', label: '中型自卸货车' },
          { value: 'H28', label: '中型特殊结构货车' },
          { value: 'H31', label: '轻型普通货车' },
          { value: 'H32', label: '轻型厢式货车' },
          { value: 'H33', label: '轻型封闭货车' },
          { value: 'H34', label: '轻型罐式货车' },
          { value: 'H35', label: '轻型平板货车' },
          { value: 'H37', label: '轻型自卸货车' },
          { value: 'H38', label: '轻型特殊结构货车' },
          { value: 'H41', label: '微型普通货车' },
          { value: 'H42', label: '微型厢式货车' },
          { value: 'H43', label: '微型封闭货车' },
          { value: 'H44', label: '微型罐式货车' },
          { value: 'H45', label: '微型自卸货车' },
          { value: 'H46', label: '微型特殊结构货车' },
          { value: 'Q11', label: '重型半挂牵引车' },
          { value: 'Q12', label: '重型全挂牵引车' },
          { value: 'Q21', label: '中型半挂牵引车' },
          { value: 'Q22', label: '中型全挂牵引车' },
          { value: 'Q31', label: '轻型半挂牵引车' },
          { value: 'Q32', label: '轻型全挂牵引车' }
        ]
      },
      {
        //2<=核定载质量<5
        value: '22',
        limit: [1, 5],
        label: '二吨至五吨货车',
        type: [
          { value: 'H21', label: '中型普通货车' },
          { value: 'H22', label: '中型厢式货车' },
          { value: 'H23', label: '中型封闭货车' },
          { value: 'H24', label: '中型罐式货车' },
          { value: 'H25', label: '中型平板货车' },
          { value: 'H26', label: '中型集装厢车' },
          { value: 'H27', label: '中型自卸货车' },
          { value: 'H28', label: '中型特殊结构货车' },
          { value: 'H31', label: '轻型普通货车' },
          { value: 'H32', label: '轻型厢式货车' },
          { value: 'H33', label: '轻型封闭货车' },
          { value: 'H34', label: '轻型罐式货车' },
          { value: 'H35', label: '轻型平板货车' },
          { value: 'H37', label: '轻型自卸货车' },
          { value: 'H38', label: '轻型特殊结构货车' },
          { value: 'H41', label: '微型普通货车' },
          { value: 'H42', label: '微型厢式货车' },
          { value: 'H43', label: '微型封闭货车' },
          { value: 'H44', label: '微型罐式货车' },
          { value: 'H45', label: '微型自卸货车' },
          { value: 'H46', label: '微型特殊结构货车' },
          { value: 'Q11', label: '重型半挂牵引车' },
          { value: 'Q12', label: '重型全挂牵引车' },
          { value: 'Q21', label: '中型半挂牵引车' },
          { value: 'Q22', label: '中型全挂牵引车' },
          { value: 'Q31', label: '轻型半挂牵引车' },
          { value: 'Q32', label: '轻型全挂牵引车' }
        ]
      },
      {
        //5<=核定载质量<10
        value: '23',
        limit: [4, 10],
        label: '五吨至十吨货车',
        type: [
          { value: 'H11', label: '重型普通货车' },
          { value: 'H12', label: '重型厢式货车' },
          { value: 'H13', label: '重型封闭货车' },
          { value: 'H14', label: '重型罐式货车' },
          { value: 'H15', label: '重型平板货车' },
          { value: 'H16', label: '重型集装厢车' },
          { value: 'H17', label: '重型自卸货车' },
          { value: 'H18', label: '重型特殊结构货车' },
          { value: 'H21', label: '中型普通货车' },
          { value: 'H22', label: '中型厢式货车' },
          { value: 'H23', label: '中型封闭货车' },
          { value: 'H24', label: '中型罐式货车' },
          { value: 'H25', label: '中型平板货车' },
          { value: 'H26', label: '中型集装厢车' },
          { value: 'H27', label: '中型自卸货车' },
          { value: 'H28', label: '中型特殊结构货车' },
          { value: 'Q11', label: '重型半挂牵引车' },
          { value: 'Q12', label: '重型全挂牵引车' },
          { value: 'Q21', label: '中型半挂牵引车' },
          { value: 'Q22', label: '中型全挂牵引车' },
          { value: 'Q31', label: '轻型半挂牵引车' },
          { value: 'Q32', label: '轻型全挂牵引车' }
        ]
      },
      {
        //10<=核定载质量
        value: '24',
        limit: [9, ''],
        label: '十吨以上货车',
        type: [
          { value: 'H11', label: '重型普通货车' },
          { value: 'H12', label: '重型厢式货车' },
          { value: 'H13', label: '重型封闭货车' },
          { value: 'H14', label: '重型罐式货车' },
          { value: 'H15', label: '重型平板货车' },
          { value: 'H16', label: '重型集装厢车' },
          { value: 'H17', label: '重型自卸货车' },
          { value: 'H18', label: '重型特殊结构货车' },
          { value: 'H21', label: '中型普通货车' },
          { value: 'H22', label: '中型厢式货车' },
          { value: 'H23', label: '中型封闭货车' },
          { value: 'H24', label: '中型罐式货车' },
          { value: 'H25', label: '中型平板货车' },
          { value: 'H26', label: '中型集装厢车' },
          { value: 'H27', label: '中型自卸货车' },
          { value: 'H28', label: '中型特殊结构货车' },
          { value: 'Q11', label: '重型半挂牵引车' },
          { value: 'Q12', label: '重型全挂牵引车' },
          { value: 'Q21', label: '中型半挂牵引车' },
          { value: 'Q22', label: '中型全挂牵引车' },
          { value: 'Q31', label: '轻型半挂牵引车' },
          { value: 'Q32', label: '轻型全挂牵引车' }
        ]
      },
      {
        //0<核定载质量<2
        value: '25',
        limit: [0, 2],
        label: '二吨以下挂车',
        type: [
          { value: 'B21', label: '中型普通半挂车' },
          { value: 'B22', label: '中型厢式半挂车' },
          { value: 'B23', label: '中型罐式半挂车' },
          { value: 'B24', label: '中型平板半挂车' },
          { value: 'B25', label: '中型集装箱半挂车' },
          { value: 'B26', label: '中型自卸半挂车' },
          { value: 'B27', label: '中型特殊结构半挂车' },
          { value: 'B31', label: '轻型普通半挂车' },
          { value: 'B32', label: '轻型厢式半挂车' },
          { value: 'B33', label: '轻型罐式半挂车' },
          { value: 'B34', label: '轻型平板半挂车' },
          { value: 'B35', label: '轻型自卸半挂车' },
          { value: 'G21', label: '中型普通全挂车' },
          { value: 'G22', label: '中型厢式全挂车' },
          { value: 'G23', label: '中型罐式全挂车' },
          { value: 'G24', label: '中型平板全挂车' },
          { value: 'G25', label: '中型集装箱全挂车' },
          { value: 'G26', label: '中型自卸全挂车' },
          { value: 'G31', label: '轻型普通全挂车' },
          { value: 'G32', label: '轻型厢式全挂车' },
          { value: 'G33', label: '轻型罐式全挂车' },
          { value: 'G34', label: '轻型平板全挂车' },
          { value: 'G35', label: '轻型自卸全挂车' },
          { value: 'Q11', label: '重型半挂牵引车' },
          { value: 'Q12', label: '重型全挂牵引车' },
          { value: 'Q21', label: '中型半挂牵引车' },
          { value: 'Q22', label: '中型全挂牵引车' },
          { value: 'Q31', label: '轻型半挂牵引车' },
          { value: 'Q32', label: '轻型全挂牵引车' }
        ]
      },
      {
        //2<=核定载质量<5
        value: '26',
        limit: [1, 5],
        label: '二吨至五吨挂车',
        type: [
          { value: 'B21', label: '中型普通半挂车' },
          { value: 'B22', label: '中型厢式半挂车' },
          { value: 'B23', label: '中型罐式半挂车' },
          { value: 'B24', label: '中型平板半挂车' },
          { value: 'B25', label: '中型集装箱半挂车' },
          { value: 'B26', label: '中型自卸半挂车' },
          { value: 'B27', label: '中型特殊结构半挂车' },
          { value: 'B31', label: '轻型普通半挂车' },
          { value: 'B32', label: '轻型厢式半挂车' },
          { value: 'B33', label: '轻型罐式半挂车' },
          { value: 'B34', label: '轻型平板半挂车' },
          { value: 'B35', label: '轻型自卸半挂车' },
          { value: 'G21', label: '中型普通全挂车' },
          { value: 'G22', label: '中型厢式全挂车' },
          { value: 'G23', label: '中型罐式全挂车' },
          { value: 'G24', label: '中型平板全挂车' },
          { value: 'G25', label: '中型集装箱全挂车' },
          { value: 'G26', label: '中型自卸全挂车' },
          { value: 'G31', label: '轻型普通全挂车' },
          { value: 'G32', label: '轻型厢式全挂车' },
          { value: 'G33', label: '轻型罐式全挂车' },
          { value: 'G34', label: '轻型平板全挂车' },
          { value: 'G35', label: '轻型自卸全挂车' },
          { value: 'Q11', label: '重型半挂牵引车' },
          { value: 'Q12', label: '重型全挂牵引车' },
          { value: 'Q21', label: '中型半挂牵引车' },
          { value: 'Q22', label: '中型全挂牵引车' },
          { value: 'Q31', label: '轻型半挂牵引车' },
          { value: 'Q32', label: '轻型全挂牵引车' }
        ]
      },
      {
        //5<=核定载质量<10
        value: '27',
        limit: [4, 10],
        label: '五吨至十吨挂车',
        type: [
          { value: 'B11', label: '重型普通半挂车' },
          { value: 'B12', label: '重型厢式半挂车' },
          { value: 'B13', label: '重型罐式半挂车' },
          { value: 'B14', label: '重型平板半挂车' },
          { value: 'B15', label: '重型集装箱半挂车' },
          { value: 'B16', label: '重型自卸半挂车' },
          { value: 'B17', label: '重型特殊结构半挂车' },
          { value: 'B21', label: '中型普通半挂车' },
          { value: 'B22', label: '中型厢式半挂车' },
          { value: 'B23', label: '中型罐式半挂车' },
          { value: 'B24', label: '中型平板半挂车' },
          { value: 'B25', label: '中型集装箱半挂车' },
          { value: 'B26', label: '中型自卸半挂车' },
          { value: 'B27', label: '中型特殊结构半挂车' },
          { value: 'G11', label: '重型普通全挂车' },
          { value: 'G12', label: '重型厢式全挂车' },
          { value: 'G13', label: '重型罐式全挂车' },
          { value: 'G14', label: '重型平板全挂车' },
          { value: 'G15', label: '重型集装箱全挂车' },
          { value: 'G16', label: '重型自卸全挂车' },
          { value: 'G21', label: '中型普通全挂车' },
          { value: 'G22', label: '中型厢式全挂车' },
          { value: 'G23', label: '中型罐式全挂车' },
          { value: 'G24', label: '中型平板全挂车' },
          { value: 'G25', label: '中型集装箱全挂车' },
          { value: 'G26', label: '中型自卸全挂车' },
          { value: 'Q11', label: '重型半挂牵引车' },
          { value: 'Q12', label: '重型全挂牵引车' },
          { value: 'Q21', label: '中型半挂牵引车' },
          { value: 'Q22', label: '中型全挂牵引车' },
          { value: 'Q31', label: '轻型半挂牵引车' },
          { value: 'Q32', label: '轻型全挂牵引车' }
        ]
      },
      {
        //10<=核定载质量
        value: '28',
        limit: [9, ''],
        label: '十吨以上挂车',
        type: [
          { value: 'B11', label: '重型普通半挂车' },
          { value: 'B12', label: '重型厢式半挂车' },
          { value: 'B13', label: '重型罐式半挂车' },
          { value: 'B14', label: '重型平板半挂车' },
          { value: 'B15', label: '重型集装箱半挂车' },
          { value: 'B16', label: '重型自卸半挂车' },
          { value: 'B17', label: '重型特殊结构半挂车' },
          { value: 'B21', label: '中型普通半挂车' },
          { value: 'B22', label: '中型厢式半挂车' },
          { value: 'B23', label: '中型罐式半挂车' },
          { value: 'B24', label: '中型平板半挂车' },
          { value: 'B25', label: '中型集装箱半挂车' },
          { value: 'B26', label: '中型自卸半挂车' },
          { value: 'B27', label: '中型特殊结构半挂车' },
          { value: 'G11', label: '重型普通全挂车' },
          { value: 'G12', label: '重型厢式全挂车' },
          { value: 'G13', label: '重型罐式全挂车' },
          { value: 'G14', label: '重型平板全挂车' },
          { value: 'G15', label: '重型集装箱全挂车' },
          { value: 'G16', label: '重型自卸全挂车' },
          { value: 'G21', label: '中型普通全挂车' },
          { value: 'G22', label: '中型厢式全挂车' },
          { value: 'G23', label: '中型罐式全挂车' },
          { value: 'G24', label: '中型平板全挂车' },
          { value: 'G25', label: '中型集装箱全挂车' },
          { value: 'G26', label: '中型自卸全挂车' },
          { value: 'Q11', label: '重型半挂牵引车' },
          { value: 'Q12', label: '重型全挂牵引车' },
          { value: 'Q21', label: '中型半挂牵引车' },
          { value: 'Q22', label: '中型全挂牵引车' },
          { value: 'Q31', label: '轻型半挂牵引车' },
          { value: 'Q32', label: '轻型全挂牵引车' }
        ]
      },
      {
        limit: [0, ''],
        value: '93',
        label: '低速载货汽车',
        type: [
          { value: 'H51', label: '低速普通货车' },
          { value: 'H52', label: '低速厢式货车' },
          { value: 'H53', label: '低速罐式货车' },
          { value: 'H54', label: '低速自卸货车' },
          { value: 'N11', label: '三轮汽车' }
        ]
      },
      {
        limit: [0, ''],
        value: '94',
        label: '三轮汽车',
        type: [
          { value: 'H51', label: '低速普通货车' },
          { value: 'H52', label: '低速厢式货车' },
          { value: 'H53', label: '低速罐式货车' },
          { value: 'H54', label: '低速自卸货车' },
          { value: 'N11', label: '三轮汽车' }
        ]
      }
    ],
    '200GUA': [
      {
        //0<核定载质量<2
        value: '25',
        limit: [0, 2],
        label: '二吨以下挂车',
        type: [
          { value: 'B21', label: '中型普通半挂车' },
          { value: 'B22', label: '中型厢式半挂车' },
          { value: 'B23', label: '中型罐式半挂车' },
          { value: 'B24', label: '中型平板半挂车' },
          { value: 'B25', label: '中型集装箱半挂车' },
          { value: 'B26', label: '中型自卸半挂车' },
          { value: 'B27', label: '中型特殊结构半挂车' },
          { value: 'B31', label: '轻型普通半挂车' },
          { value: 'B32', label: '轻型厢式半挂车' },
          { value: 'B33', label: '轻型罐式半挂车' },
          { value: 'B34', label: '轻型平板半挂车' },
          { value: 'B35', label: '轻型自卸半挂车' },
          { value: 'G21', label: '中型普通全挂车' },
          { value: 'G22', label: '中型厢式全挂车' },
          { value: 'G23', label: '中型罐式全挂车' },
          { value: 'G24', label: '中型平板全挂车' },
          { value: 'G25', label: '中型集装箱全挂车' },
          { value: 'G26', label: '中型自卸全挂车' },
          { value: 'G31', label: '轻型普通全挂车' },
          { value: 'G32', label: '轻型厢式全挂车' },
          { value: 'G33', label: '轻型罐式全挂车' },
          { value: 'G34', label: '轻型平板全挂车' },
          { value: 'G35', label: '轻型自卸全挂车' },
          { value: 'Q11', label: '重型半挂牵引车' },
          { value: 'Q12', label: '重型全挂牵引车' },
          { value: 'Q21', label: '中型半挂牵引车' },
          { value: 'Q22', label: '中型全挂牵引车' },
          { value: 'Q31', label: '轻型半挂牵引车' },
          { value: 'Q32', label: '轻型全挂牵引车' }
        ]
      },
      {
        //2<=核定载质量<5
        value: '26',
        limit: [1, 5],
        label: '二吨至五吨挂车',
        type: [
          { value: 'B21', label: '中型普通半挂车' },
          { value: 'B22', label: '中型厢式半挂车' },
          { value: 'B23', label: '中型罐式半挂车' },
          { value: 'B24', label: '中型平板半挂车' },
          { value: 'B25', label: '中型集装箱半挂车' },
          { value: 'B26', label: '中型自卸半挂车' },
          { value: 'B27', label: '中型特殊结构半挂车' },
          { value: 'B31', label: '轻型普通半挂车' },
          { value: 'B32', label: '轻型厢式半挂车' },
          { value: 'B33', label: '轻型罐式半挂车' },
          { value: 'B34', label: '轻型平板半挂车' },
          { value: 'B35', label: '轻型自卸半挂车' },
          { value: 'G21', label: '中型普通全挂车' },
          { value: 'G22', label: '中型厢式全挂车' },
          { value: 'G23', label: '中型罐式全挂车' },
          { value: 'G24', label: '中型平板全挂车' },
          { value: 'G25', label: '中型集装箱全挂车' },
          { value: 'G26', label: '中型自卸全挂车' },
          { value: 'G31', label: '轻型普通全挂车' },
          { value: 'G32', label: '轻型厢式全挂车' },
          { value: 'G33', label: '轻型罐式全挂车' },
          { value: 'G34', label: '轻型平板全挂车' },
          { value: 'G35', label: '轻型自卸全挂车' },
          { value: 'Q11', label: '重型半挂牵引车' },
          { value: 'Q12', label: '重型全挂牵引车' },
          { value: 'Q21', label: '中型半挂牵引车' },
          { value: 'Q22', label: '中型全挂牵引车' },
          { value: 'Q31', label: '轻型半挂牵引车' },
          { value: 'Q32', label: '轻型全挂牵引车' }
        ]
      },
      {
        //5<=核定载质量<10
        value: '27',
        limit: [4, 10],
        label: '五吨至十吨挂车',
        type: [
          { value: 'B11', label: '重型普通半挂车' },
          { value: 'B12', label: '重型厢式半挂车' },
          { value: 'B13', label: '重型罐式半挂车' },
          { value: 'B14', label: '重型平板半挂车' },
          { value: 'B15', label: '重型集装箱半挂车' },
          { value: 'B16', label: '重型自卸半挂车' },
          { value: 'B17', label: '重型特殊结构半挂车' },
          { value: 'B21', label: '中型普通半挂车' },
          { value: 'B22', label: '中型厢式半挂车' },
          { value: 'B23', label: '中型罐式半挂车' },
          { value: 'B24', label: '中型平板半挂车' },
          { value: 'B25', label: '中型集装箱半挂车' },
          { value: 'B26', label: '中型自卸半挂车' },
          { value: 'B27', label: '中型特殊结构半挂车' },
          { value: 'G11', label: '重型普通全挂车' },
          { value: 'G12', label: '重型厢式全挂车' },
          { value: 'G13', label: '重型罐式全挂车' },
          { value: 'G14', label: '重型平板全挂车' },
          { value: 'G15', label: '重型集装箱全挂车' },
          { value: 'G16', label: '重型自卸全挂车' },
          { value: 'G21', label: '中型普通全挂车' },
          { value: 'G22', label: '中型厢式全挂车' },
          { value: 'G23', label: '中型罐式全挂车' },
          { value: 'G24', label: '中型平板全挂车' },
          { value: 'G25', label: '中型集装箱全挂车' },
          { value: 'G26', label: '中型自卸全挂车' },
          { value: 'Q11', label: '重型半挂牵引车' },
          { value: 'Q12', label: '重型全挂牵引车' },
          { value: 'Q21', label: '中型半挂牵引车' },
          { value: 'Q22', label: '中型全挂牵引车' },
          { value: 'Q31', label: '轻型半挂牵引车' },
          { value: 'Q32', label: '轻型全挂牵引车' }
        ]
      },
      {
        //10<=核定载质量
        value: '28',
        limit: [9, ''],
        label: '十吨以上挂车',
        type: [
          { value: 'B11', label: '重型普通半挂车' },
          { value: 'B12', label: '重型厢式半挂车' },
          { value: 'B13', label: '重型罐式半挂车' },
          { value: 'B14', label: '重型平板半挂车' },
          { value: 'B15', label: '重型集装箱半挂车' },
          { value: 'B16', label: '重型自卸半挂车' },
          { value: 'B17', label: '重型特殊结构半挂车' },
          { value: 'B21', label: '中型普通半挂车' },
          { value: 'B22', label: '中型厢式半挂车' },
          { value: 'B23', label: '中型罐式半挂车' },
          { value: 'B24', label: '中型平板半挂车' },
          { value: 'B25', label: '中型集装箱半挂车' },
          { value: 'B26', label: '中型自卸半挂车' },
          { value: 'B27', label: '中型特殊结构半挂车' },
          { value: 'G11', label: '重型普通全挂车' },
          { value: 'G12', label: '重型厢式全挂车' },
          { value: 'G13', label: '重型罐式全挂车' },
          { value: 'G14', label: '重型平板全挂车' },
          { value: 'G15', label: '重型集装箱全挂车' },
          { value: 'G16', label: '重型自卸全挂车' },
          { value: 'G21', label: '中型普通全挂车' },
          { value: 'G22', label: '中型厢式全挂车' },
          { value: 'G23', label: '中型罐式全挂车' },
          { value: 'G24', label: '中型平板全挂车' },
          { value: 'G25', label: '中型集装箱全挂车' },
          { value: 'G26', label: '中型自卸全挂车' },
          { value: 'Q11', label: '重型半挂牵引车' },
          { value: 'Q12', label: '重型全挂牵引车' },
          { value: 'Q21', label: '中型半挂牵引车' },
          { value: 'Q22', label: '中型全挂牵引车' },
          { value: 'Q31', label: '轻型半挂牵引车' },
          { value: 'Q32', label: '轻型全挂牵引车' }
        ]
      }
    ]
  }

/**
 * 山东营运车限制字段:
 * 已上牌车辆-不可修改限制字段的值,其他,有值的字段使用平台数据,无值的字段则用查车数据填充
 * 未上牌车辆-可以修改限制的字段的值,走正常流程 
 */
export const SD_IMMUTABLE_FIELD = [
    'licenseNo', //车牌号码
    'licenseTypeCode', //号牌种类
    'frameNo', //车架号
    'engineNo', //发动机号
    // 'carKindCode', //车辆种类
    // 'carKindCodeShow', //车辆种类细类
    'vehicleCategory', //交管种类
    'useNatureShow', //使用性质
    'brandName', //品牌型号|车辆品牌
    'singeinDate', //初登日期
    'chgOwnerDate', //过户日期|转移登记日期
    'completeKerbMass', //整备质量
    'tonCount', //核定载质量
    'exhaustScale', //排量
    'factory', //制造厂名称
    'powerType', //能源种类|燃料种类
    'power', //功率
    // 'seatCount', //核定载客数
]
// 号牌种类下拉数据
export const LICENSE_TYPE_OPTIONS = [
    { value: "01", name: '大型汽车号牌' }, { value: "02", name: '小型汽车号牌' },
    { value: "03", name: '使馆汽车号牌' }, { value: "04", name: '领馆汽车号牌' },
    { value: "05", name: '境外汽车号牌' },
    { value: "18", name: '试验汽车号牌' },
    { value: "15", name: 'T挂车号牌' }, { value: "16", name: '教练汽车号牌' },
    { value: "20", name: '临时入境汽车号牌' }, { value: "22", name: '临时行驶车号牌' },
    { value: "23", name: '警用汽车号牌' },{ value: "26", name: '香港入出境车' },
    { value: "27", name: '澳门入出境车' },{ value: "38", name: '大型警车' },
    { value: "30", name: '燃油助力车' },{ value: "33", name: '应急号牌' },
    { value: "51", name: '大型新能源汽车' },{ value: "52", name: '小型新能源汽车' }, 
    { value: "31", name: '武警号牌' },
    { value: "32", name: '军队号牌' }, { value: "99", name: '其它号牌' },
    { value: "13", name: '农用运输车号牌' },
]
// 号牌颜色下拉数据
export const LICENSE_COLOR_OPTIONS = [
    { value: "01", name: '蓝' }, { value: "02", name: '黑' },
    { value: "03", name: '白' }, { value: "04", name: '黄' },
    { value: "05", name: '白蓝' }, { value: "06", name: '渐变绿' },
    { value: "07", name: '黄绿' }, { value: "99", name: '其他' }
]
// 号牌种类下拉数据
export const MT_LICENSE_TYPE_OPTIONS = [
    { value: "07", name: '两、三轮摩托车号牌' }, { value: "08", name: '轻便摩托车号牌' },
    { value: "09", name: '使馆摩托车号牌' }, { value: "10", name: '领馆摩托车号牌' },
    { value: "11", name: '境外摩托车号牌' }, { value: "12", name: '外籍摩托车号牌' },
    { value: "17", name: '教练摩托车号牌' }, { value: "19", name: '试验摩托车号牌' },
    { value: "24", name: '警备摩托车' }, { value: "21", name: '临时入境摩托车号牌' },
]

export const carColorList = [
    { value: "001", name: '白色' }, { value: "002", name: '灰色' },
    { value: "003", name: '黄色' }, { value: "004", name: '粉色' },
    { value: "005", name: '红色' }, { value: "006", name: '紫色'},
    { value: "007", name: '绿色' },{ value: "008", name: '蓝色' },
    { value: "009", name: '棕色' }, { value: "010", name: '黑色' },
    { value: "999", name: '其他' },
]
// 非北京燃油种类
const POWER_TYPE_LIST = [
    { key: '0', name: '燃油' },
    { key: '1', name: '纯电动' },
    { key: '2', name: '燃料电池' },
    { key: '3', name: '插电式混合动力' },
    { key: '4', name: '其他混合动力' }
];
// 北京燃油种类
const BJ_POWER_TYPE_LIST = [
    { key: 'A', name: '汽油' },
    { key: 'B', name: '柴油' },
    { key: 'C', name: '电' },
    { key: 'D', name: '混合油' },
    { key: 'E', name: '天然气' },
    { key: 'F', name: '液化石油气' },
    { key: 'L', name: '甲醇' },
    { key: 'M', name: '乙醇' },
    { key: 'N', name: '太阳能' },
    { key: 'O', name: '混合动力' },
    { key: 'Y', name: '无' },
    { key: 'Z', name: '其他' }
];
export default {
    JQ_RISK_CODE,
    SY_RISK_CODE,
    XNY_RISK_CODE,
    CS_FJINS,
    CS_FJINS_XNY,
    RISK_RELATION,
    SY_RISK,
    XNY_RISK,
    JQ_RISK,
    COVERAGE_NEW,
    COVERAGE_List,
    COVERAGE_List_Sd,
    COVERAGE_List_XNY,
    COVERAGE_List_XNY_Sd,
    LATELY_VERSION_LIST,
    LATELY_VERSION_LIST_XNY,
    BASE_BEAN,
    RISK_TIPS,
    RISK_TIPS_XNY,
    IMG_TIPS,
    CAR_BEANS,
    DEPTCODE,
    COVERAGE_OBJECT,
    COVERAGE_OBJECT_XNY,
    RISK_LIMITS_LINK,
    RISK_LIMITS_LINK_XNY,
    RISK_OPTION,
    RISK_OPTION_XNY,
    SALES_AREA,
    SD_IMMUTABLE_FIELD,
    MT_LICENSE_TYPE_OPTIONS,
    LICENSE_COLOR_OPTIONS,
    LICENSE_TYPE_OPTIONS,
    POWER_TYPE_LIST,
    BJ_POWER_TYPE_LIST,
};
